/* tslint:disable */
/* eslint-disable */
/**
 * Aisha
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { AxiosInstance, AxiosPromise, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
import type { Configuration } from './configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import type { RequestArgs } from './base';
import { DUMMY_BASE_URL, assertParamExists, createRequestFunction, serializeDataIfNeeded, setBearerAuthToObject, setSearchParams, toPathString } from './common';
// @ts-ignore
import { BASE_PATH, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * This class is used to define the output of the activity.
 * @export
 * @interface ActivityOut
 */
export interface ActivityOut {
    /**
     * 
     * @type {string}
     * @memberof ActivityOut
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ActivityOut
     */
    'table_name': string;
    /**
     * 
     * @type {string}
     * @memberof ActivityOut
     */
    'instance_id': string;
    /**
     * 
     * @type {ActivityTypeEnum}
     * @memberof ActivityOut
     */
    'type': ActivityTypeEnum;
    /**
     * 
     * @type {Array<FieldDiffOut>}
     * @memberof ActivityOut
     */
    'diffs': Array<FieldDiffOut> | null;
    /**
     * 
     * @type {string}
     * @memberof ActivityOut
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof ActivityOut
     */
    'client_id': string;
    /**
     * 
     * @type {string}
     * @memberof ActivityOut
     */
    'user_id': string;
}


/**
 * Enum representing the type of activity.
 * @export
 * @enum {string}
 */

export const ActivityTypeEnum = {
    Create: 'create',
    Update: 'update',
    Delete: 'delete'
} as const;

export type ActivityTypeEnum = typeof ActivityTypeEnum[keyof typeof ActivityTypeEnum];


/**
 * Output model for a chat child prompt.
 * @export
 * @interface ChatChildPromptOut
 */
export interface ChatChildPromptOut {
    /**
     * 
     * @type {string}
     * @memberof ChatChildPromptOut
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ChatChildPromptOut
     */
    'id': string;
}
/**
 * Input model for creating a new chat.
 * @export
 * @interface ChatCreateInput
 */
export interface ChatCreateInput {
    /**
     * 
     * @type {string}
     * @memberof ChatCreateInput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ChatCreateInput
     */
    'llm_id': string;
}
/**
 * Input model for creating a new chat message.
 * @export
 * @interface ChatMessageCreateInput
 */
export interface ChatMessageCreateInput {
    /**
     * 
     * @type {string}
     * @memberof ChatMessageCreateInput
     */
    'user_prompt': string;
    /**
     * 
     * @type {boolean}
     * @memberof ChatMessageCreateInput
     */
    'give_structured_output'?: boolean | null;
    /**
     * 
     * @type {object}
     * @memberof ChatMessageCreateInput
     */
    'execute_parameters'?: object | null;
}
/**
 * Output model for a chat message.
 * @export
 * @interface ChatMessageOut
 */
export interface ChatMessageOut {
    /**
     * 
     * @type {string}
     * @memberof ChatMessageOut
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageOut
     */
    'message': string;
    /**
     * 
     * @type {ChatMessageRoleEnum}
     * @memberof ChatMessageOut
     */
    'role': ChatMessageRoleEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ChatMessageOut
     */
    'structured_response': boolean;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageOut
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageOut
     */
    'updated_at': string;
}


/**
 * Enum representing the role of a chat message.
 * @export
 * @enum {string}
 */

export const ChatMessageRoleEnum = {
    User: 'user',
    Assistant: 'assistant'
} as const;

export type ChatMessageRoleEnum = typeof ChatMessageRoleEnum[keyof typeof ChatMessageRoleEnum];


/**
 * Output model for a chat.
 * @export
 * @interface ChatOut
 */
export interface ChatOut {
    /**
     * 
     * @type {string}
     * @memberof ChatOut
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ChatOut
     */
    'name': string;
    /**
     * 
     * @type {LLMModelOut}
     * @memberof ChatOut
     */
    'llm': LLMModelOut;
    /**
     * 
     * @type {LLMModelOut}
     * @memberof ChatOut
     */
    'fallback_llm'?: LLMModelOut | null;
    /**
     * 
     * @type {string}
     * @memberof ChatOut
     */
    'user_id': string;
    /**
     * 
     * @type {string}
     * @memberof ChatOut
     */
    'client_id': string;
    /**
     * 
     * @type {string}
     * @memberof ChatOut
     */
    'system_prompt'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ChatOut
     */
    'temperature'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ChatOut
     */
    'top_p'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ChatOut
     */
    'top_k'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ChatOut
     */
    'frequency_penalty'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ChatOut
     */
    'presence_penalty'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ChatOut
     */
    'max_tokens'?: number | null;
    /**
     * 
     * @type {Array<ParameterField>}
     * @memberof ChatOut
     */
    'parameters'?: Array<ParameterField> | null;
    /**
     * 
     * @type {Array<DataSourceOut>}
     * @memberof ChatOut
     */
    'data_sources': Array<DataSourceOut>;
    /**
     * 
     * @type {Array<ChatChildPromptOut>}
     * @memberof ChatOut
     */
    'child_prompts': Array<ChatChildPromptOut>;
    /**
     * 
     * @type {Array<StructuredOutputFieldOutput>}
     * @memberof ChatOut
     */
    'structured_output'?: Array<StructuredOutputFieldOutput> | null;
    /**
     * 
     * @type {string}
     * @memberof ChatOut
     */
    'user_prompt_template'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatOut
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof ChatOut
     */
    'updated_at': string;
}
/**
 * Represents a metric for a specific day.  Attributes:     date (datetime): The date for which the metric is calculated.     value (float): The value of the metric for the given date.     client_ids (list[str]): List of unique client IDs for the given date.
 * @export
 * @interface ChatPerDayMetric
 */
export interface ChatPerDayMetric {
    /**
     * 
     * @type {string}
     * @memberof ChatPerDayMetric
     */
    'date': string;
    /**
     * 
     * @type {number}
     * @memberof ChatPerDayMetric
     */
    'value': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatPerDayMetric
     */
    'client_ids': Array<string>;
}
/**
 * Input model for updating a chat.
 * @export
 * @interface ChatUpdateInput
 */
export interface ChatUpdateInput {
    /**
     * 
     * @type {string}
     * @memberof ChatUpdateInput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ChatUpdateInput
     */
    'llm_id': string;
    /**
     * 
     * @type {string}
     * @memberof ChatUpdateInput
     */
    'fallback_llm_id'?: string | null;
    /**
     * 
     * @type {Array<StructuredOutputFieldInput>}
     * @memberof ChatUpdateInput
     */
    'structured_output'?: Array<StructuredOutputFieldInput> | null;
    /**
     * 
     * @type {string}
     * @memberof ChatUpdateInput
     */
    'user_prompt_template'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatUpdateInput
     */
    'data_sources'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatUpdateInput
     */
    'child_prompts'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ChatUpdateInput
     */
    'system_prompt'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ChatUpdateInput
     */
    'temperature'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ChatUpdateInput
     */
    'top_p'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ChatUpdateInput
     */
    'top_k'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ChatUpdateInput
     */
    'frequency_penalty'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ChatUpdateInput
     */
    'presence_penalty'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ChatUpdateInput
     */
    'max_tokens'?: number | null;
    /**
     * 
     * @type {Array<ParameterField>}
     * @memberof ChatUpdateInput
     */
    'parameters'?: Array<ParameterField> | null;
}
/**
 * Output model for a child prompts
 * @export
 * @interface ChildPromptOut
 */
export interface ChildPromptOut {
    /**
     * 
     * @type {string}
     * @memberof ChildPromptOut
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ChildPromptOut
     */
    'name': string;
}
/**
 * Represents a metric for a specific day.
 * @export
 * @interface DailyErrorVolumeMetric
 */
export interface DailyErrorVolumeMetric {
    /**
     * 
     * @type {string}
     * @memberof DailyErrorVolumeMetric
     */
    'date': string;
    /**
     * 
     * @type {number}
     * @memberof DailyErrorVolumeMetric
     */
    'value': number;
    /**
     * 
     * @type {ErrorTypeEnum}
     * @memberof DailyErrorVolumeMetric
     */
    'error_type': ErrorTypeEnum;
}


/**
 * Represents a metric for a specific day.  Attributes:     date (datetime): The date for which the metric is calculated.     value (float): The value of the metric for the given date.
 * @export
 * @interface DailyMetric
 */
export interface DailyMetric {
    /**
     * 
     * @type {string}
     * @memberof DailyMetric
     */
    'date': string;
    /**
     * 
     * @type {number}
     * @memberof DailyMetric
     */
    'value': number;
    /**
     * 
     * @type {LLMAgentEnum}
     * @memberof DailyMetric
     */
    'llm_agent': LLMAgentEnum;
}


/**
 * Input model for creating a data source.
 * @export
 * @interface DataSourceCreate
 */
export interface DataSourceCreate {
    /**
     * 
     * @type {string}
     * @memberof DataSourceCreate
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof DataSourceCreate
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof DataSourceCreate
     */
    'cache_timeout': number;
    /**
     * 
     * @type {Array<ParameterField>}
     * @memberof DataSourceCreate
     */
    'parameters'?: Array<ParameterField> | null;
    /**
     * 
     * @type {DataSourceTypeEnum}
     * @memberof DataSourceCreate
     */
    'type': DataSourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof DataSourceCreate
     */
    'content': string;
}


/**
 * Schema for the response data of a prompt. This will be used to return data source data from the API.
 * @export
 * @interface DataSourceOut
 */
export interface DataSourceOut {
    /**
     * 
     * @type {string}
     * @memberof DataSourceOut
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DataSourceOut
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof DataSourceOut
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof DataSourceOut
     */
    'cache_timeout': number;
    /**
     * 
     * @type {Array<ParameterField>}
     * @memberof DataSourceOut
     */
    'parameters'?: Array<ParameterField> | null;
    /**
     * 
     * @type {DataSourceTypeEnum}
     * @memberof DataSourceOut
     */
    'type': DataSourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof DataSourceOut
     */
    'content'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataSourceOut
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof DataSourceOut
     */
    'updated_at': string;
}


/**
 * Input model for previewing a data source.
 * @export
 * @interface DataSourcePreviewInput
 */
export interface DataSourcePreviewInput {
    /**
     * 
     * @type {Array<ParameterField>}
     * @memberof DataSourcePreviewInput
     */
    'parameters'?: Array<ParameterField> | null;
    /**
     * 
     * @type {DataSourceTypeEnum}
     * @memberof DataSourcePreviewInput
     */
    'type': DataSourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof DataSourcePreviewInput
     */
    'content': string;
    /**
     * 
     * @type {object}
     * @memberof DataSourcePreviewInput
     */
    'execute_parameters'?: object | null;
    /**
     * 
     * @type {OverrideUser}
     * @memberof DataSourcePreviewInput
     */
    'override_user'?: OverrideUser | null;
}


/**
 * Input model for running a data source.
 * @export
 * @interface DataSourceRunInput
 */
export interface DataSourceRunInput {
    /**
     * 
     * @type {object}
     * @memberof DataSourceRunInput
     */
    'execute_parameters'?: object | null;
    /**
     * 
     * @type {OverrideUser}
     * @memberof DataSourceRunInput
     */
    'override_user'?: OverrideUser | null;
}
/**
 * Enum representing the type of data source.
 * @export
 * @enum {string}
 */

export const DataSourceTypeEnum = {
    BigqueryCsv: 'bigquery_csv',
    BigqueryJson: 'bigquery_json',
    StaticJson: 'static_json',
    StaticCsv: 'static_csv',
    StaticTxt: 'static_txt',
    Api: 'api'
} as const;

export type DataSourceTypeEnum = typeof DataSourceTypeEnum[keyof typeof DataSourceTypeEnum];


/**
 * Input model for updating a data source.
 * @export
 * @interface DataSourceUpdate
 */
export interface DataSourceUpdate {
    /**
     * 
     * @type {string}
     * @memberof DataSourceUpdate
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof DataSourceUpdate
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof DataSourceUpdate
     */
    'cache_timeout': number;
    /**
     * 
     * @type {Array<ParameterField>}
     * @memberof DataSourceUpdate
     */
    'parameters'?: Array<ParameterField> | null;
    /**
     * 
     * @type {DataSourceTypeEnum}
     * @memberof DataSourceUpdate
     */
    'type': DataSourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof DataSourceUpdate
     */
    'content': string;
}


/**
 * Model representing the output of a nested field.
 * @export
 * @interface DynamicField
 */
export interface DynamicField {
    /**
     * 
     * @type {string}
     * @memberof DynamicField
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof DynamicField
     */
    'required'?: boolean | null;
    /**
     * 
     * @type {FieldTypeEnum}
     * @memberof DynamicField
     */
    'type': FieldTypeEnum;
}


/**
 * 
 * @export
 * @interface ErrorDetails
 */
export interface ErrorDetails {
    /**
     * 
     * @type {string}
     * @memberof ErrorDetails
     */
    'type': string;
    /**
     * 
     * @type {Array<ErrorDetailsLocInner>}
     * @memberof ErrorDetails
     */
    'loc': Array<ErrorDetailsLocInner>;
    /**
     * 
     * @type {string}
     * @memberof ErrorDetails
     */
    'msg': string;
    /**
     * 
     * @type {any}
     * @memberof ErrorDetails
     */
    'input': any;
    /**
     * 
     * @type {object}
     * @memberof ErrorDetails
     */
    'ctx'?: object;
}
/**
 * 
 * @export
 * @interface ErrorDetailsLocInner
 */
export interface ErrorDetailsLocInner {
}
/**
 * Represents the type of error.
 * @export
 * @enum {string}
 */

export const ErrorTypeEnum = {
    Chat: 'chat',
    Prompt: 'prompt',
    Unknown: 'unknown'
} as const;

export type ErrorTypeEnum = typeof ErrorTypeEnum[keyof typeof ErrorTypeEnum];


/**
 * Input model for creating a new facade.
 * @export
 * @interface FacadeCreateInput
 */
export interface FacadeCreateInput {
    /**
     * 
     * @type {string}
     * @memberof FacadeCreateInput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FacadeCreateInput
     */
    'prompt_id': string;
    /**
     * 
     * @type {number}
     * @memberof FacadeCreateInput
     */
    'cache_timeout': number;
    /**
     * 
     * @type {Array<Rule>}
     * @memberof FacadeCreateInput
     */
    'rules'?: Array<Rule> | null;
    /**
     * 
     * @type {FacadeTypeEnum}
     * @memberof FacadeCreateInput
     */
    'type': FacadeTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FacadeCreateInput
     */
    'chat_system_prompt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FacadeCreateInput
     */
    'chat_user_prompt_template'?: string | null;
}


/**
 * Output model for facade data.
 * @export
 * @interface FacadeOut
 */
export interface FacadeOut {
    /**
     * 
     * @type {string}
     * @memberof FacadeOut
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof FacadeOut
     */
    'name': string;
    /**
     * 
     * @type {PromptOut}
     * @memberof FacadeOut
     */
    'prompt': PromptOut;
    /**
     * 
     * @type {number}
     * @memberof FacadeOut
     */
    'cache_timeout': number;
    /**
     * 
     * @type {string}
     * @memberof FacadeOut
     */
    'created_at': string;
    /**
     * 
     * @type {Array<Rule>}
     * @memberof FacadeOut
     */
    'rules'?: Array<Rule> | null;
    /**
     * 
     * @type {string}
     * @memberof FacadeOut
     */
    'updated_at': string;
    /**
     * 
     * @type {FacadeTypeEnum}
     * @memberof FacadeOut
     */
    'type': FacadeTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FacadeOut
     */
    'chat_system_prompt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FacadeOut
     */
    'chat_user_prompt_template'?: string | null;
}


/**
 * Input model for previewing a facade.
 * @export
 * @interface FacadePreviewInput
 */
export interface FacadePreviewInput {
    /**
     * 
     * @type {object}
     * @memberof FacadePreviewInput
     */
    'execute_parameters'?: object | null;
    /**
     * 
     * @type {OverrideUser}
     * @memberof FacadePreviewInput
     */
    'override_user'?: OverrideUser | null;
}
/**
 * Input model for running a facade.
 * @export
 * @interface FacadeRunInput
 */
export interface FacadeRunInput {
    /**
     * 
     * @type {object}
     * @memberof FacadeRunInput
     */
    'execute_parameters'?: object | null;
}
/**
 * Enum representing the type of facade.  Attributes:     CHAT: Represents a chat facade.     SINGLE_RESPONSE: Represents a single response facade.
 * @export
 * @enum {string}
 */

export const FacadeTypeEnum = {
    Chat: 'chat',
    SingleResponse: 'single_response'
} as const;

export type FacadeTypeEnum = typeof FacadeTypeEnum[keyof typeof FacadeTypeEnum];


/**
 * Input model for updating an existing facade.
 * @export
 * @interface FacadeUpdateInput
 */
export interface FacadeUpdateInput {
    /**
     * 
     * @type {string}
     * @memberof FacadeUpdateInput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FacadeUpdateInput
     */
    'prompt_id': string;
    /**
     * 
     * @type {number}
     * @memberof FacadeUpdateInput
     */
    'cache_timeout': number;
    /**
     * 
     * @type {Array<Rule>}
     * @memberof FacadeUpdateInput
     */
    'rules'?: Array<Rule> | null;
    /**
     * 
     * @type {FacadeTypeEnum}
     * @memberof FacadeUpdateInput
     */
    'type': FacadeTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FacadeUpdateInput
     */
    'chat_system_prompt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FacadeUpdateInput
     */
    'chat_user_prompt_template'?: string | null;
}


/**
 * This class is used to define the output of the field diff.
 * @export
 * @interface FieldDiffOut
 */
export interface FieldDiffOut {
    /**
     * 
     * @type {string}
     * @memberof FieldDiffOut
     */
    'field': string;
    /**
     * 
     * @type {any}
     * @memberof FieldDiffOut
     */
    'old_value': any;
    /**
     * 
     * @type {any}
     * @memberof FieldDiffOut
     */
    'new_value': any;
}
/**
 * Enum representing the supported Field Types.
 * @export
 * @enum {string}
 */

export const FieldTypeEnum = {
    String: 'string',
    Integer: 'integer',
    Number: 'number',
    Boolean: 'boolean',
    Object: 'object',
    Array: 'array'
} as const;

export type FieldTypeEnum = typeof FieldTypeEnum[keyof typeof FieldTypeEnum];


/**
 * 
 * @export
 * @interface HTTPValidationError
 */
export interface HTTPValidationError {
    /**
     * 
     * @type {Array<ValidationError>}
     * @memberof HTTPValidationError
     */
    'detail'?: Array<ValidationError>;
}
/**
 * Initial chat history for a new chat.
 * @export
 * @interface InitialChatHistory
 */
export interface InitialChatHistory {
    /**
     * 
     * @type {string}
     * @memberof InitialChatHistory
     */
    'message': string;
    /**
     * 
     * @type {ChatMessageRoleEnum}
     * @memberof InitialChatHistory
     */
    'role': ChatMessageRoleEnum;
}


/**
 * Job model
 * @export
 * @interface Job
 */
export interface Job {
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    'job_id': string;
    /**
     * 
     * @type {JobStatus}
     * @memberof Job
     */
    'status': JobStatus;
    /**
     * 
     * @type {JobResult}
     * @memberof Job
     */
    'result'?: JobResult | null;
    /**
     * 
     * @type {boolean}
     * @memberof Job
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {Array<Job>}
     * @memberof Job
     */
    'child_jobs'?: Array<Job> | null;
}


/**
 * Job result model
 * @export
 * @interface JobResult
 */
export interface JobResult {
    /**
     * 
     * @type {string}
     * @memberof JobResult
     */
    'error_message'?: string | null;
    /**
     * 
     * @type {Array<ErrorDetails>}
     * @memberof JobResult
     */
    'error_fields'?: Array<ErrorDetails> | null;
    /**
     * 
     * @type {}
     * @memberof JobResult
     */
    'task_output'?:  | null;
}
/**
 * Job Status
 * @export
 * @enum {string}
 */

export const JobStatus = {
    Pending: 'PENDING',
    Received: 'RECEIVED',
    Started: 'STARTED',
    Success: 'SUCCESS',
    Failure: 'FAILURE',
    Revoked: 'REVOKED',
    Retry: 'RETRY',
    Ignored: 'IGNORED'
} as const;

export type JobStatus = typeof JobStatus[keyof typeof JobStatus];


/**
 * Enum representing the supported LLM agents.  Attributes:     GEMINI: Represents the Gemini LLM agent.     OPENAI: Represents the OpenAI LLM agent.     CLAUDE: Represents the Claude LLM agent.     GROK:   Represents the Grok LLM agent.
 * @export
 * @enum {string}
 */

export const LLMAgentEnum = {
    Gemini: 'gemini',
    Openai: 'openai',
    Claude: 'claude',
    Grok: 'grok',
    Deepseek: 'deepseek'
} as const;

export type LLMAgentEnum = typeof LLMAgentEnum[keyof typeof LLMAgentEnum];


/**
 * LLM agent output schema.
 * @export
 * @interface LLMAgentOut
 */
export interface LLMAgentOut {
    /**
     * 
     * @type {LLMAgentEnum}
     * @memberof LLMAgentOut
     */
    'value': LLMAgentEnum;
    /**
     * 
     * @type {string}
     * @memberof LLMAgentOut
     */
    'label': string;
}


/**
 * Enum representing the features of an LLM.
 * @export
 * @enum {string}
 */

export const LLMFeaturesEnum = {
    TopP: 'top_p',
    Temperature: 'temperature',
    MaxTokens: 'max_tokens',
    TopK: 'top_k',
    FrequencyPenalty: 'frequency_penalty',
    PresencePenalty: 'presence_penalty',
    StructuredOutput: 'structured_output'
} as const;

export type LLMFeaturesEnum = typeof LLMFeaturesEnum[keyof typeof LLMFeaturesEnum];


/**
 * LLM model output schema.
 * @export
 * @interface LLMModelOut
 */
export interface LLMModelOut {
    /**
     * 
     * @type {string}
     * @memberof LLMModelOut
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof LLMModelOut
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof LLMModelOut
     */
    'llm_model': string;
    /**
     * 
     * @type {LLMAgentEnum}
     * @memberof LLMModelOut
     */
    'llm_agent': LLMAgentEnum;
    /**
     * 
     * @type {Array<LLMFeaturesEnum>}
     * @memberof LLMModelOut
     */
    'features'?: Array<LLMFeaturesEnum> | null;
    /**
     * 
     * @type {string}
     * @memberof LLMModelOut
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof LLMModelOut
     */
    'updated_at': string;
}


/**
 * LLM model upsert schema.
 * @export
 * @interface LLMModelUpsert
 */
export interface LLMModelUpsert {
    /**
     * 
     * @type {string}
     * @memberof LLMModelUpsert
     */
    'llm_model': string;
    /**
     * 
     * @type {string}
     * @memberof LLMModelUpsert
     */
    'name': string;
    /**
     * 
     * @type {LLMAgentEnum}
     * @memberof LLMModelUpsert
     */
    'llm_agent': LLMAgentEnum;
    /**
     * 
     * @type {Array<LLMFeaturesEnum>}
     * @memberof LLMModelUpsert
     */
    'features': Array<LLMFeaturesEnum>;
}


/**
 * Model representing the input of a Override User Field.
 * @export
 * @interface OverrideUser
 */
export interface OverrideUser {
    /**
     * 
     * @type {number}
     * @memberof OverrideUser
     */
    'client_id'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OverrideUser
     */
    'country_id'?: number | null;
}
/**
 * Model representing the output of a Parameter Field.
 * @export
 * @interface ParameterField
 */
export interface ParameterField {
    /**
     * 
     * @type {string}
     * @memberof ParameterField
     */
    'name': string;
    /**
     * 
     * @type {FieldTypeEnum}
     * @memberof ParameterField
     */
    'type': FieldTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ParameterField
     */
    'required'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof ParameterField
     */
    'description'?: string | null;
}


/**
 * Model for previewing a prompt without saving it.
 * @export
 * @interface PreviewPrompt
 */
export interface PreviewPrompt {
    /**
     * 
     * @type {string}
     * @memberof PreviewPrompt
     */
    'user_prompt': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PreviewPrompt
     */
    'data_sources': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PreviewPrompt
     */
    'child_prompts': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PreviewPrompt
     */
    'system_prompt'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PreviewPrompt
     */
    'temperature'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PreviewPrompt
     */
    'top_p'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PreviewPrompt
     */
    'top_k'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PreviewPrompt
     */
    'frequency_penalty'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PreviewPrompt
     */
    'presence_penalty'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PreviewPrompt
     */
    'max_tokens'?: number | null;
    /**
     * 
     * @type {Array<ParameterField>}
     * @memberof PreviewPrompt
     */
    'parameters'?: Array<ParameterField> | null;
    /**
     * 
     * @type {object}
     * @memberof PreviewPrompt
     */
    'execute_parameters'?: object | null;
    /**
     * 
     * @type {string}
     * @memberof PreviewPrompt
     */
    'llm_id': string;
    /**
     * 
     * @type {Array<StructuredOutputFieldInput>}
     * @memberof PreviewPrompt
     */
    'structured_output'?: Array<StructuredOutputFieldInput> | null;
    /**
     * 
     * @type {Array<InitialChatHistory>}
     * @memberof PreviewPrompt
     */
    'initial_chat_history'?: Array<InitialChatHistory> | null;
    /**
     * 
     * @type {OverrideUser}
     * @memberof PreviewPrompt
     */
    'override_user'?: OverrideUser | null;
}
/**
 * Input model for creating a new prompt.
 * @export
 * @interface PromptCreateInput
 */
export interface PromptCreateInput {
    /**
     * 
     * @type {string}
     * @memberof PromptCreateInput
     */
    'name': string;
    /**
     * 
     * @type {PromptVersionCreateInput}
     * @memberof PromptCreateInput
     */
    'version': PromptVersionCreateInput;
}
/**
 * Output model for a prompt log.
 * @export
 * @interface PromptLogOut
 */
export interface PromptLogOut {
    /**
     * 
     * @type {string}
     * @memberof PromptLogOut
     */
    'id': string;
    /**
     * 
     * @type {object}
     * @memberof PromptLogOut
     */
    'request': object;
    /**
     * 
     * @type {object}
     * @memberof PromptLogOut
     */
    'response': object;
    /**
     * 
     * @type {object}
     * @memberof PromptLogOut
     */
    'data_sources': object;
    /**
     * 
     * @type {string}
     * @memberof PromptLogOut
     */
    'prompt_id': string | null;
    /**
     * 
     * @type {string}
     * @memberof PromptLogOut
     */
    'chat_id': string | null;
    /**
     * 
     * @type {number}
     * @memberof PromptLogOut
     */
    'prompt_tokens'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PromptLogOut
     */
    'completion_tokens'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PromptLogOut
     */
    'total_tokens'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PromptLogOut
     */
    'elapsed_time': number;
    /**
     * 
     * @type {boolean}
     * @memberof PromptLogOut
     */
    'is_succeed': boolean;
    /**
     * 
     * @type {string}
     * @memberof PromptLogOut
     */
    'created_at': string;
}
/**
 * Model representing the output of a prompt.
 * @export
 * @interface PromptOut
 */
export interface PromptOut {
    /**
     * 
     * @type {string}
     * @memberof PromptOut
     */
    'version': string;
    /**
     * 
     * @type {string}
     * @memberof PromptOut
     */
    'tag'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PromptOut
     */
    'user_prompt': string;
    /**
     * 
     * @type {string}
     * @memberof PromptOut
     */
    'system_prompt'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PromptOut
     */
    'temperature'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PromptOut
     */
    'top_p'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PromptOut
     */
    'top_k'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PromptOut
     */
    'frequency_penalty'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PromptOut
     */
    'presence_penalty'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PromptOut
     */
    'max_tokens'?: number | null;
    /**
     * 
     * @type {Array<StructuredOutputFieldOutput>}
     * @memberof PromptOut
     */
    'structured_output'?: Array<StructuredOutputFieldOutput> | null;
    /**
     * 
     * @type {Array<InitialChatHistory>}
     * @memberof PromptOut
     */
    'initial_chat_history'?: Array<InitialChatHistory> | null;
    /**
     * 
     * @type {Array<ParameterField>}
     * @memberof PromptOut
     */
    'parameters'?: Array<ParameterField> | null;
    /**
     * 
     * @type {LLMModelOut}
     * @memberof PromptOut
     */
    'llm': LLMModelOut;
    /**
     * 
     * @type {LLMModelOut}
     * @memberof PromptOut
     */
    'fallback_llm'?: LLMModelOut | null;
    /**
     * 
     * @type {Array<DataSourceOut>}
     * @memberof PromptOut
     */
    'data_sources': Array<DataSourceOut>;
    /**
     * 
     * @type {PromptVersionTypeEnum}
     * @memberof PromptOut
     */
    'type': PromptVersionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PromptOut
     */
    'created_by_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PromptOut
     */
    'version_id': string;
    /**
     * 
     * @type {string}
     * @memberof PromptOut
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PromptOut
     */
    'name': string;
    /**
     * 
     * @type {PromptStatusEnum}
     * @memberof PromptOut
     */
    'status': PromptStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PromptOut
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof PromptOut
     */
    'updated_at': string;
}


/**
 * Input model for running a prompt.
 * @export
 * @interface PromptRunInput
 */
export interface PromptRunInput {
    /**
     * 
     * @type {object}
     * @memberof PromptRunInput
     */
    'execute_parameters'?: object | null;
    /**
     * 
     * @type {OverrideUser}
     * @memberof PromptRunInput
     */
    'override_user'?: OverrideUser | null;
}
/**
 * Enum representing the statuses of a prompt.  Attributes:     DRAFT: Represents a prompt that is in draft mode and can be updated or deleted.     ACTIVE: Represents a prompt that is active and ready to be used.             Prompts with this status cannot be updated or deleted.     ARCHIVE: Represents a prompt that is archived and cannot be used.
 * @export
 * @enum {string}
 */

export const PromptStatusEnum = {
    Draft: 'draft',
    Active: 'active',
    Archive: 'archive'
} as const;

export type PromptStatusEnum = typeof PromptStatusEnum[keyof typeof PromptStatusEnum];


/**
 * Input model for changing the status of a prompt.
 * @export
 * @interface PromptStatusInput
 */
export interface PromptStatusInput {
    /**
     * 
     * @type {PromptStatusEnum}
     * @memberof PromptStatusInput
     */
    'new_status': PromptStatusEnum;
}


/**
 * Prompt config schema.
 * @export
 * @interface PromptTestCaseConfig
 */
export interface PromptTestCaseConfig {
    /**
     * 
     * @type {Array<number>}
     * @memberof PromptTestCaseConfig
     */
    'temperature'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof PromptTestCaseConfig
     */
    'top_p'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof PromptTestCaseConfig
     */
    'top_k'?: Array<number> | null;
}
/**
 * Prompt test case create input schema.
 * @export
 * @interface PromptTestCaseCreateInput
 */
export interface PromptTestCaseCreateInput {
    /**
     * 
     * @type {string}
     * @memberof PromptTestCaseCreateInput
     */
    'prompt_id': string;
    /**
     * 
     * @type {string}
     * @memberof PromptTestCaseCreateInput
     */
    'system_prompt': string;
    /**
     * 
     * @type {Array<PromptTestCaseParameter>}
     * @memberof PromptTestCaseCreateInput
     */
    'prompt_parameters'?: Array<PromptTestCaseParameter> | null;
    /**
     * 
     * @type {PromptTestCaseConfig}
     * @memberof PromptTestCaseCreateInput
     */
    'prompt_config'?: PromptTestCaseConfig | null;
    /**
     * 
     * @type {string}
     * @memberof PromptTestCaseCreateInput
     */
    'llm_id': string;
    /**
     * 
     * @type {number}
     * @memberof PromptTestCaseCreateInput
     */
    'iteration': number;
}
/**
 * Prompt test case schema.
 * @export
 * @interface PromptTestCaseOut
 */
export interface PromptTestCaseOut {
    /**
     * 
     * @type {string}
     * @memberof PromptTestCaseOut
     */
    'id': string;
    /**
     * 
     * @type {PromptOut}
     * @memberof PromptTestCaseOut
     */
    'prompt': PromptOut;
    /**
     * 
     * @type {PromptTestCaseStatusEnum}
     * @memberof PromptTestCaseOut
     */
    'status': PromptTestCaseStatusEnum;
    /**
     * 
     * @type {LLMModelOut}
     * @memberof PromptTestCaseOut
     */
    'llm': LLMModelOut;
    /**
     * 
     * @type {number}
     * @memberof PromptTestCaseOut
     */
    'iteration': number;
    /**
     * 
     * @type {string}
     * @memberof PromptTestCaseOut
     */
    'bg_task_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PromptTestCaseOut
     */
    'system_prompt'?: string | null;
    /**
     * 
     * @type {Array<PromptTestCaseParameter>}
     * @memberof PromptTestCaseOut
     */
    'prompt_parameters'?: Array<PromptTestCaseParameter> | null;
    /**
     * 
     * @type {PromptTestCaseConfig}
     * @memberof PromptTestCaseOut
     */
    'prompt_config'?: PromptTestCaseConfig | null;
    /**
     * 
     * @type {string}
     * @memberof PromptTestCaseOut
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof PromptTestCaseOut
     */
    'updated_at': string;
}


/**
 * Prompt test case parameter schema.
 * @export
 * @interface PromptTestCaseParameter
 */
export interface PromptTestCaseParameter {
    /**
     * 
     * @type {string}
     * @memberof PromptTestCaseParameter
     */
    'name': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PromptTestCaseParameter
     */
    'values': Array<string>;
    /**
     * 
     * @type {FieldTypeEnum}
     * @memberof PromptTestCaseParameter
     */
    'type': FieldTypeEnum;
}


/**
 * Prompt test case result schema.
 * @export
 * @interface PromptTestCaseResultOut
 */
export interface PromptTestCaseResultOut {
    /**
     * 
     * @type {string}
     * @memberof PromptTestCaseResultOut
     */
    'id': string;
    /**
     * 
     * @type {PromptTestCaseResultStatusEnum}
     * @memberof PromptTestCaseResultOut
     */
    'status': PromptTestCaseResultStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PromptTestCaseResultOut
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof PromptTestCaseResultOut
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof PromptTestCaseResultOut
     */
    'rendered_prompt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PromptTestCaseResultOut
     */
    'error_message'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof PromptTestCaseResultOut
     */
    'prompt_parameters'?: object | null;
    /**
     * 
     * @type {object}
     * @memberof PromptTestCaseResultOut
     */
    'prompt_config'?: object | null;
    /**
     * 
     * @type {number}
     * @memberof PromptTestCaseResultOut
     */
    'score'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PromptTestCaseResultOut
     */
    'feedback'?: string | null;
    /**
     * 
     * @type {Array<any>}
     * @memberof PromptTestCaseResultOut
     */
    'user_prompt_improvements'?: Array<any> | null;
    /**
     * 
     * @type {Array<any>}
     * @memberof PromptTestCaseResultOut
     */
    'system_prompt_improvements'?: Array<any> | null;
    /**
     * 
     * @type {string}
     * @memberof PromptTestCaseResultOut
     */
    'suggested_user_prompt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PromptTestCaseResultOut
     */
    'suggested_system_prompt'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof PromptTestCaseResultOut
     */
    'raw_result'?: object | null;
}


/**
 * Enum representing the status of a prompt test case result.
 * @export
 * @enum {string}
 */

export const PromptTestCaseResultStatusEnum = {
    Pending: 'pending',
    Succeeded: 'succeeded',
    Failed: 'failed'
} as const;

export type PromptTestCaseResultStatusEnum = typeof PromptTestCaseResultStatusEnum[keyof typeof PromptTestCaseResultStatusEnum];


/**
 * Enum representing the status of a prompt test case.
 * @export
 * @enum {string}
 */

export const PromptTestCaseStatusEnum = {
    Pending: 'pending',
    Succeeded: 'succeeded',
    Failed: 'failed'
} as const;

export type PromptTestCaseStatusEnum = typeof PromptTestCaseStatusEnum[keyof typeof PromptTestCaseStatusEnum];


/**
 * Output model for prompt children
 * @export
 * @interface PromptTreeOut
 */
export interface PromptTreeOut {
    /**
     * 
     * @type {string}
     * @memberof PromptTreeOut
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PromptTreeOut
     */
    'name': string;
    /**
     * 
     * @type {LLMModelOut}
     * @memberof PromptTreeOut
     */
    'llm': LLMModelOut;
    /**
     * 
     * @type {Array<PromptTreeOut>}
     * @memberof PromptTreeOut
     */
    'children'?: Array<PromptTreeOut>;
}
/**
 * Input model for updating an existing prompt.
 * @export
 * @interface PromptUpdateInput
 */
export interface PromptUpdateInput {
    /**
     * 
     * @type {string}
     * @memberof PromptUpdateInput
     */
    'name': string;
    /**
     * 
     * @type {PromptVersionCreateInput}
     * @memberof PromptUpdateInput
     */
    'version'?: PromptVersionCreateInput | null;
    /**
     * 
     * @type {string}
     * @memberof PromptUpdateInput
     */
    'current_version_id'?: string | null;
}
/**
 * Input model for creating a new prompt version.
 * @export
 * @interface PromptVersionCreateInput
 */
export interface PromptVersionCreateInput {
    /**
     * 
     * @type {string}
     * @memberof PromptVersionCreateInput
     */
    'commit_message': string;
    /**
     * 
     * @type {string}
     * @memberof PromptVersionCreateInput
     */
    'tag'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PromptVersionCreateInput
     */
    'user_prompt': string;
    /**
     * 
     * @type {string}
     * @memberof PromptVersionCreateInput
     */
    'system_prompt'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PromptVersionCreateInput
     */
    'temperature'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PromptVersionCreateInput
     */
    'top_p'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PromptVersionCreateInput
     */
    'top_k'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PromptVersionCreateInput
     */
    'frequency_penalty'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PromptVersionCreateInput
     */
    'presence_penalty'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PromptVersionCreateInput
     */
    'max_tokens'?: number | null;
    /**
     * 
     * @type {Array<StructuredOutputFieldInput>}
     * @memberof PromptVersionCreateInput
     */
    'structured_output'?: Array<StructuredOutputFieldInput> | null;
    /**
     * 
     * @type {Array<InitialChatHistory>}
     * @memberof PromptVersionCreateInput
     */
    'initial_chat_history'?: Array<InitialChatHistory> | null;
    /**
     * 
     * @type {Array<ParameterField>}
     * @memberof PromptVersionCreateInput
     */
    'parameters'?: Array<ParameterField> | null;
    /**
     * 
     * @type {string}
     * @memberof PromptVersionCreateInput
     */
    'llm_id': string;
    /**
     * 
     * @type {string}
     * @memberof PromptVersionCreateInput
     */
    'fallback_llm_id'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PromptVersionCreateInput
     */
    'data_sources': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PromptVersionCreateInput
     */
    'child_prompts': Array<string>;
    /**
     * 
     * @type {PromptVersionTypeEnum}
     * @memberof PromptVersionCreateInput
     */
    'type': PromptVersionTypeEnum;
}


/**
 * Output model for a prompt version
 * @export
 * @interface PromptVersionOut
 */
export interface PromptVersionOut {
    /**
     * 
     * @type {string}
     * @memberof PromptVersionOut
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PromptVersionOut
     */
    'version': string;
    /**
     * 
     * @type {string}
     * @memberof PromptVersionOut
     */
    'tag'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PromptVersionOut
     */
    'commit_message': string;
    /**
     * 
     * @type {string}
     * @memberof PromptVersionOut
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof PromptVersionOut
     */
    'user_prompt': string;
    /**
     * 
     * @type {string}
     * @memberof PromptVersionOut
     */
    'system_prompt'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PromptVersionOut
     */
    'temperature'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PromptVersionOut
     */
    'top_p'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PromptVersionOut
     */
    'top_k'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PromptVersionOut
     */
    'frequency_penalty'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PromptVersionOut
     */
    'presence_penalty'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PromptVersionOut
     */
    'max_tokens'?: number | null;
    /**
     * 
     * @type {Array<StructuredOutputFieldOutput>}
     * @memberof PromptVersionOut
     */
    'structured_output'?: Array<StructuredOutputFieldOutput> | null;
    /**
     * 
     * @type {Array<InitialChatHistory>}
     * @memberof PromptVersionOut
     */
    'initial_chat_history'?: Array<InitialChatHistory> | null;
    /**
     * 
     * @type {Array<ParameterField>}
     * @memberof PromptVersionOut
     */
    'parameters'?: Array<ParameterField> | null;
    /**
     * 
     * @type {LLMModelOut}
     * @memberof PromptVersionOut
     */
    'llm': LLMModelOut;
    /**
     * 
     * @type {LLMModelOut}
     * @memberof PromptVersionOut
     */
    'fallback_llm'?: LLMModelOut | null;
    /**
     * 
     * @type {Array<DataSourceOut>}
     * @memberof PromptVersionOut
     */
    'data_sources': Array<DataSourceOut>;
    /**
     * 
     * @type {PromptVersionTypeEnum}
     * @memberof PromptVersionOut
     */
    'type': PromptVersionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PromptVersionOut
     */
    'created_by_id'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PromptVersionOut
     */
    'is_current': boolean;
    /**
     * 
     * @type {Array<ChildPromptOut>}
     * @memberof PromptVersionOut
     */
    'child_prompts': Array<ChildPromptOut>;
}


/**
 * Enum representing the type of  Prompt Version Type
 * @export
 * @enum {string}
 */

export const PromptVersionTypeEnum = {
    Minor: 'minor',
    Major: 'major'
} as const;

export type PromptVersionTypeEnum = typeof PromptVersionTypeEnum[keyof typeof PromptVersionTypeEnum];


/**
 * Model for a single rule
 * @export
 * @interface Rule
 */
export interface Rule {
    /**
     * 
     * @type {RuleType}
     * @memberof Rule
     */
    'type': RuleType;
    /**
     * 
     * @type {string}
     * @memberof Rule
     */
    'value': string;
    /**
     * 
     * @type {string}
     * @memberof Rule
     */
    'prompt_id': string;
}


/**
 * Enum for rule types
 * @export
 * @enum {string}
 */

export const RuleType = {
    Client: 'client',
    Country: 'country'
} as const;

export type RuleType = typeof RuleType[keyof typeof RuleType];


/**
 * Model representing the output of a Structured Output Field.
 * @export
 * @interface StructuredOutputFieldInput
 */
export interface StructuredOutputFieldInput {
    /**
     * 
     * @type {string}
     * @memberof StructuredOutputFieldInput
     */
    'name': string;
    /**
     * 
     * @type {FieldTypeEnum}
     * @memberof StructuredOutputFieldInput
     */
    'type': FieldTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof StructuredOutputFieldInput
     */
    'required'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof StructuredOutputFieldInput
     */
    'description'?: string | null;
    /**
     * 
     * @type {Array<DynamicField>}
     * @memberof StructuredOutputFieldInput
     */
    'properties'?: Array<DynamicField> | null;
}


/**
 * Model representing the output of a Structured Output Field.
 * @export
 * @interface StructuredOutputFieldOutput
 */
export interface StructuredOutputFieldOutput {
    /**
     * 
     * @type {string}
     * @memberof StructuredOutputFieldOutput
     */
    'name': string;
    /**
     * 
     * @type {FieldTypeEnum}
     * @memberof StructuredOutputFieldOutput
     */
    'type': FieldTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof StructuredOutputFieldOutput
     */
    'required'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof StructuredOutputFieldOutput
     */
    'description'?: string | null;
    /**
     * 
     * @type {Array<DynamicField>}
     * @memberof StructuredOutputFieldOutput
     */
    'properties'?: Array<DynamicField> | null;
}


/**
 * 
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * 
     * @type {Array<ValidationErrorLocInner>}
     * @memberof ValidationError
     */
    'loc': Array<ValidationErrorLocInner>;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'msg': string;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface ValidationErrorLocInner
 */
export interface ValidationErrorLocInner {
}

/**
 * ActivitiesApi - axios parameter creator
 * @export
 */
export const ActivitiesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all activities for a client.
         * @summary Get Activities
         * @param {number} [page] The page number (1-based indexing)
         * @param {number} [pageSize] Number of items per page
         * @param {string | null} [tableName] The name of the table
         * @param {string | null} [instanceId] The id of the instance
         * @param {ActivityTypeEnum | null} [type] The type of the activity
         * @param {string | null} [startDate] The start date of the activity
         * @param {string | null} [endDate] The end date of the activity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivitiesActivitiesGet: async (page?: number, pageSize?: number, tableName?: string | null, instanceId?: string | null, type?: ActivityTypeEnum | null, startDate?: string | null, endDate?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/activities/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (tableName !== undefined) {
                localVarQueryParameter['table_name'] = tableName;
            }

            if (instanceId !== undefined) {
                localVarQueryParameter['instance_id'] = instanceId;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get an activity by its id.
         * @summary Get Activity
         * @param {string} activityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityActivitiesActivityIdGet: async (activityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activityId' is not null or undefined
            assertParamExists('getActivityActivitiesActivityIdGet', 'activityId', activityId)
            const localVarPath = `/activities/{activity_id}`
                .replace(`{${"activity_id"}}`, encodeURIComponent(String(activityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ActivitiesApi - functional programming interface
 * @export
 */
export const ActivitiesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ActivitiesApiAxiosParamCreator(configuration)
    return {
        /**
         * Get all activities for a client.
         * @summary Get Activities
         * @param {number} [page] The page number (1-based indexing)
         * @param {number} [pageSize] Number of items per page
         * @param {string | null} [tableName] The name of the table
         * @param {string | null} [instanceId] The id of the instance
         * @param {ActivityTypeEnum | null} [type] The type of the activity
         * @param {string | null} [startDate] The start date of the activity
         * @param {string | null} [endDate] The end date of the activity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActivitiesActivitiesGet(page?: number, pageSize?: number, tableName?: string | null, instanceId?: string | null, type?: ActivityTypeEnum | null, startDate?: string | null, endDate?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ActivityOut>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActivitiesActivitiesGet(page, pageSize, tableName, instanceId, type, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivitiesApi.getActivitiesActivitiesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get an activity by its id.
         * @summary Get Activity
         * @param {string} activityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActivityActivitiesActivityIdGet(activityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActivityOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActivityActivitiesActivityIdGet(activityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivitiesApi.getActivityActivitiesActivityIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ActivitiesApi - factory interface
 * @export
 */
export const ActivitiesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ActivitiesApiFp(configuration)
    return {
        /**
         * Get all activities for a client.
         * @summary Get Activities
         * @param {number} [page] The page number (1-based indexing)
         * @param {number} [pageSize] Number of items per page
         * @param {string | null} [tableName] The name of the table
         * @param {string | null} [instanceId] The id of the instance
         * @param {ActivityTypeEnum | null} [type] The type of the activity
         * @param {string | null} [startDate] The start date of the activity
         * @param {string | null} [endDate] The end date of the activity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivitiesActivitiesGet(page?: number, pageSize?: number, tableName?: string | null, instanceId?: string | null, type?: ActivityTypeEnum | null, startDate?: string | null, endDate?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<Array<ActivityOut>> {
            return localVarFp.getActivitiesActivitiesGet(page, pageSize, tableName, instanceId, type, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * Get an activity by its id.
         * @summary Get Activity
         * @param {string} activityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityActivitiesActivityIdGet(activityId: string, options?: RawAxiosRequestConfig): AxiosPromise<ActivityOut> {
            return localVarFp.getActivityActivitiesActivityIdGet(activityId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ActivitiesApi - object-oriented interface
 * @export
 * @class ActivitiesApi
 * @extends {BaseAPI}
 */
export class ActivitiesApi extends BaseAPI {
    /**
     * Get all activities for a client.
     * @summary Get Activities
     * @param {number} [page] The page number (1-based indexing)
     * @param {number} [pageSize] Number of items per page
     * @param {string | null} [tableName] The name of the table
     * @param {string | null} [instanceId] The id of the instance
     * @param {ActivityTypeEnum | null} [type] The type of the activity
     * @param {string | null} [startDate] The start date of the activity
     * @param {string | null} [endDate] The end date of the activity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesApi
     */
    public getActivitiesActivitiesGet(page?: number, pageSize?: number, tableName?: string | null, instanceId?: string | null, type?: ActivityTypeEnum | null, startDate?: string | null, endDate?: string | null, options?: RawAxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).getActivitiesActivitiesGet(page, pageSize, tableName, instanceId, type, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get an activity by its id.
     * @summary Get Activity
     * @param {string} activityId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesApi
     */
    public getActivityActivitiesActivityIdGet(activityId: string, options?: RawAxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).getActivityActivitiesActivityIdGet(activityId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AppDocsApi - axios parameter creator
 * @export
 */
export const AppDocsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Serve a specific file from the docs folder.  Args:     request: Request     filename: doc file name
         * @summary Get App Doc
         * @param {string} filename 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppDocAppDocsFilenameGet: async (filename: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'filename' is not null or undefined
            assertParamExists('getAppDocAppDocsFilenameGet', 'filename', filename)
            const localVarPath = `/app-docs/{filename}`
                .replace(`{${"filename"}}`, encodeURIComponent(String(filename)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all files in the docs folder.  Args:     request: Request
         * @summary List App Docs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAppDocsAppDocsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/app-docs/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AppDocsApi - functional programming interface
 * @export
 */
export const AppDocsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AppDocsApiAxiosParamCreator(configuration)
    return {
        /**
         * Serve a specific file from the docs folder.  Args:     request: Request     filename: doc file name
         * @summary Get App Doc
         * @param {string} filename 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppDocAppDocsFilenameGet(filename: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppDocAppDocsFilenameGet(filename, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppDocsApi.getAppDocAppDocsFilenameGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all files in the docs folder.  Args:     request: Request
         * @summary List App Docs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAppDocsAppDocsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string | null>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAppDocsAppDocsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppDocsApi.listAppDocsAppDocsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AppDocsApi - factory interface
 * @export
 */
export const AppDocsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AppDocsApiFp(configuration)
    return {
        /**
         * Serve a specific file from the docs folder.  Args:     request: Request     filename: doc file name
         * @summary Get App Doc
         * @param {string} filename 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppDocAppDocsFilenameGet(filename: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getAppDocAppDocsFilenameGet(filename, options).then((request) => request(axios, basePath));
        },
        /**
         * List all files in the docs folder.  Args:     request: Request
         * @summary List App Docs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAppDocsAppDocsGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<string | null>> {
            return localVarFp.listAppDocsAppDocsGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AppDocsApi - object-oriented interface
 * @export
 * @class AppDocsApi
 * @extends {BaseAPI}
 */
export class AppDocsApi extends BaseAPI {
    /**
     * Serve a specific file from the docs folder.  Args:     request: Request     filename: doc file name
     * @summary Get App Doc
     * @param {string} filename 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppDocsApi
     */
    public getAppDocAppDocsFilenameGet(filename: string, options?: RawAxiosRequestConfig) {
        return AppDocsApiFp(this.configuration).getAppDocAppDocsFilenameGet(filename, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all files in the docs folder.  Args:     request: Request
     * @summary List App Docs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppDocsApi
     */
    public listAppDocsAppDocsGet(options?: RawAxiosRequestConfig) {
        return AppDocsApiFp(this.configuration).listAppDocsAppDocsGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ChatApi - axios parameter creator
 * @export
 */
export const ChatApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new chat.
         * @summary Create Chat
         * @param {ChatCreateInput} chatCreateInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createChatChatPost: async (chatCreateInput: ChatCreateInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatCreateInput' is not null or undefined
            assertParamExists('createChatChatPost', 'chatCreateInput', chatCreateInput)
            const localVarPath = `/chat/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chatCreateInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new chat message.
         * @summary Create Chat Message
         * @param {string} chatId 
         * @param {ChatMessageCreateInput} chatMessageCreateInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createChatMessageChatChatIdMessagesPost: async (chatId: string, chatMessageCreateInput: ChatMessageCreateInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('createChatMessageChatChatIdMessagesPost', 'chatId', chatId)
            // verify required parameter 'chatMessageCreateInput' is not null or undefined
            assertParamExists('createChatMessageChatChatIdMessagesPost', 'chatMessageCreateInput', chatMessageCreateInput)
            const localVarPath = `/chat/{chat_id}/messages`
                .replace(`{${"chat_id"}}`, encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chatMessageCreateInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a chat by ID.
         * @summary Delete Chat
         * @param {string} chatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteChatChatChatIdDelete: async (chatId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('deleteChatChatChatIdDelete', 'chatId', chatId)
            const localVarPath = `/chat/{chat_id}`
                .replace(`{${"chat_id"}}`, encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a chat by ID.
         * @summary Get Chat
         * @param {string} chatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatChatChatIdGet: async (chatId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('getChatChatChatIdGet', 'chatId', chatId)
            const localVarPath = `/chat/{chat_id}`
                .replace(`{${"chat_id"}}`, encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all messages for a chat.
         * @summary Get Chat Messages
         * @param {string} chatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatMessagesChatChatIdMessagesGet: async (chatId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('getChatMessagesChatChatIdMessagesGet', 'chatId', chatId)
            const localVarPath = `/chat/{chat_id}/messages`
                .replace(`{${"chat_id"}}`, encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all chats for a user.
         * @summary Get Chats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatsChatGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/chat/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a chat.
         * @summary Update Chat
         * @param {string} chatId 
         * @param {ChatUpdateInput} chatUpdateInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateChatChatChatIdPut: async (chatId: string, chatUpdateInput: ChatUpdateInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('updateChatChatChatIdPut', 'chatId', chatId)
            // verify required parameter 'chatUpdateInput' is not null or undefined
            assertParamExists('updateChatChatChatIdPut', 'chatUpdateInput', chatUpdateInput)
            const localVarPath = `/chat/{chat_id}`
                .replace(`{${"chat_id"}}`, encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chatUpdateInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChatApi - functional programming interface
 * @export
 */
export const ChatApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChatApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new chat.
         * @summary Create Chat
         * @param {ChatCreateInput} chatCreateInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createChatChatPost(chatCreateInput: ChatCreateInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createChatChatPost(chatCreateInput, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.createChatChatPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new chat message.
         * @summary Create Chat Message
         * @param {string} chatId 
         * @param {ChatMessageCreateInput} chatMessageCreateInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createChatMessageChatChatIdMessagesPost(chatId: string, chatMessageCreateInput: ChatMessageCreateInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Job>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createChatMessageChatChatIdMessagesPost(chatId, chatMessageCreateInput, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.createChatMessageChatChatIdMessagesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a chat by ID.
         * @summary Delete Chat
         * @param {string} chatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteChatChatChatIdDelete(chatId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteChatChatChatIdDelete(chatId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.deleteChatChatChatIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a chat by ID.
         * @summary Get Chat
         * @param {string} chatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChatChatChatIdGet(chatId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChatChatChatIdGet(chatId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.getChatChatChatIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all messages for a chat.
         * @summary Get Chat Messages
         * @param {string} chatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChatMessagesChatChatIdMessagesGet(chatId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ChatMessageOut>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChatMessagesChatChatIdMessagesGet(chatId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.getChatMessagesChatChatIdMessagesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all chats for a user.
         * @summary Get Chats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChatsChatGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ChatOut>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChatsChatGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.getChatsChatGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a chat.
         * @summary Update Chat
         * @param {string} chatId 
         * @param {ChatUpdateInput} chatUpdateInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateChatChatChatIdPut(chatId: string, chatUpdateInput: ChatUpdateInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateChatChatChatIdPut(chatId, chatUpdateInput, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.updateChatChatChatIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ChatApi - factory interface
 * @export
 */
export const ChatApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChatApiFp(configuration)
    return {
        /**
         * Create a new chat.
         * @summary Create Chat
         * @param {ChatCreateInput} chatCreateInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createChatChatPost(chatCreateInput: ChatCreateInput, options?: RawAxiosRequestConfig): AxiosPromise<ChatOut> {
            return localVarFp.createChatChatPost(chatCreateInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new chat message.
         * @summary Create Chat Message
         * @param {string} chatId 
         * @param {ChatMessageCreateInput} chatMessageCreateInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createChatMessageChatChatIdMessagesPost(chatId: string, chatMessageCreateInput: ChatMessageCreateInput, options?: RawAxiosRequestConfig): AxiosPromise<Job> {
            return localVarFp.createChatMessageChatChatIdMessagesPost(chatId, chatMessageCreateInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a chat by ID.
         * @summary Delete Chat
         * @param {string} chatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteChatChatChatIdDelete(chatId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteChatChatChatIdDelete(chatId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a chat by ID.
         * @summary Get Chat
         * @param {string} chatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatChatChatIdGet(chatId: string, options?: RawAxiosRequestConfig): AxiosPromise<ChatOut> {
            return localVarFp.getChatChatChatIdGet(chatId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all messages for a chat.
         * @summary Get Chat Messages
         * @param {string} chatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatMessagesChatChatIdMessagesGet(chatId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ChatMessageOut>> {
            return localVarFp.getChatMessagesChatChatIdMessagesGet(chatId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all chats for a user.
         * @summary Get Chats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatsChatGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<ChatOut>> {
            return localVarFp.getChatsChatGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Update a chat.
         * @summary Update Chat
         * @param {string} chatId 
         * @param {ChatUpdateInput} chatUpdateInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateChatChatChatIdPut(chatId: string, chatUpdateInput: ChatUpdateInput, options?: RawAxiosRequestConfig): AxiosPromise<ChatOut> {
            return localVarFp.updateChatChatChatIdPut(chatId, chatUpdateInput, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ChatApi - object-oriented interface
 * @export
 * @class ChatApi
 * @extends {BaseAPI}
 */
export class ChatApi extends BaseAPI {
    /**
     * Create a new chat.
     * @summary Create Chat
     * @param {ChatCreateInput} chatCreateInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public createChatChatPost(chatCreateInput: ChatCreateInput, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).createChatChatPost(chatCreateInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new chat message.
     * @summary Create Chat Message
     * @param {string} chatId 
     * @param {ChatMessageCreateInput} chatMessageCreateInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public createChatMessageChatChatIdMessagesPost(chatId: string, chatMessageCreateInput: ChatMessageCreateInput, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).createChatMessageChatChatIdMessagesPost(chatId, chatMessageCreateInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a chat by ID.
     * @summary Delete Chat
     * @param {string} chatId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public deleteChatChatChatIdDelete(chatId: string, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).deleteChatChatChatIdDelete(chatId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a chat by ID.
     * @summary Get Chat
     * @param {string} chatId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public getChatChatChatIdGet(chatId: string, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).getChatChatChatIdGet(chatId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all messages for a chat.
     * @summary Get Chat Messages
     * @param {string} chatId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public getChatMessagesChatChatIdMessagesGet(chatId: string, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).getChatMessagesChatChatIdMessagesGet(chatId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all chats for a user.
     * @summary Get Chats
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public getChatsChatGet(options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).getChatsChatGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a chat.
     * @summary Update Chat
     * @param {string} chatId 
     * @param {ChatUpdateInput} chatUpdateInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public updateChatChatChatIdPut(chatId: string, chatUpdateInput: ChatUpdateInput, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).updateChatChatChatIdPut(chatId, chatUpdateInput, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DataSourcesApi - axios parameter creator
 * @export
 */
export const DataSourcesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates a new data source.
         * @summary Create Data Source
         * @param {DataSourceCreate} dataSourceCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDataSourceDataSourcesPost: async (dataSourceCreate: DataSourceCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataSourceCreate' is not null or undefined
            assertParamExists('createDataSourceDataSourcesPost', 'dataSourceCreate', dataSourceCreate)
            const localVarPath = `/data-sources/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dataSourceCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Executes a data source run based on the given input and context.  Args:     request: Request     data_source_id (str): The ID of the data source to run.     item (DataSourceRunInput): Input data containing parameters needed for execution.     source_repository (DataSourceRepository): The repository instance to interact with the data source.  Returns:     dict: A dictionary containing the result of the executed data source run.  Raises:     HTTPException: If the specified data source cannot be found, a 404 error will be raised.
         * @summary Data Source Run
         * @param {string} dataSourceId 
         * @param {DataSourceRunInput} dataSourceRunInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dataSourceRunDataSourcesDataSourceIdRunPost: async (dataSourceId: string, dataSourceRunInput: DataSourceRunInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataSourceId' is not null or undefined
            assertParamExists('dataSourceRunDataSourcesDataSourceIdRunPost', 'dataSourceId', dataSourceId)
            // verify required parameter 'dataSourceRunInput' is not null or undefined
            assertParamExists('dataSourceRunDataSourcesDataSourceIdRunPost', 'dataSourceRunInput', dataSourceRunInput)
            const localVarPath = `/data-sources/{data_source_id}/run`
                .replace(`{${"data_source_id"}}`, encodeURIComponent(String(dataSourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dataSourceRunInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a data source.
         * @summary Delete Data Source
         * @param {string} dataSourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDataSourceDataSourcesDataSourceIdDelete: async (dataSourceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataSourceId' is not null or undefined
            assertParamExists('deleteDataSourceDataSourcesDataSourceIdDelete', 'dataSourceId', dataSourceId)
            const localVarPath = `/data-sources/{data_source_id}`
                .replace(`{${"data_source_id"}}`, encodeURIComponent(String(dataSourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves details for a specific data source.  Args:     request: Request     data_source_id (str): The ID of the data source to retrieve.     source_repository: DataSourceRepository  Returns:     dict: A dictionary containing data source details.
         * @summary Get Data Source
         * @param {string} dataSourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataSourceDataSourcesDataSourceIdGet: async (dataSourceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataSourceId' is not null or undefined
            assertParamExists('getDataSourceDataSourcesDataSourceIdGet', 'dataSourceId', dataSourceId)
            const localVarPath = `/data-sources/{data_source_id}`
                .replace(`{${"data_source_id"}}`, encodeURIComponent(String(dataSourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists all data sources.  Args:     request: Request     source_repository: Data source repository  Returns:     list: A list of dictionaries, each representing a prompt.
         * @summary List Data Sources
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDataSourcesDataSourcesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/data-sources/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Preview a data source.
         * @summary Preview Data Source
         * @param {DataSourcePreviewInput} dataSourcePreviewInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewDataSourceDataSourcesPreviewPost: async (dataSourcePreviewInput: DataSourcePreviewInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataSourcePreviewInput' is not null or undefined
            assertParamExists('previewDataSourceDataSourcesPreviewPost', 'dataSourcePreviewInput', dataSourcePreviewInput)
            const localVarPath = `/data-sources/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dataSourcePreviewInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Purges the cache for a data source.
         * @summary Purge Data Source Cache
         * @param {string} dataSourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purgeDataSourceCacheDataSourcesDataSourceIdPurgeCachePost: async (dataSourceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataSourceId' is not null or undefined
            assertParamExists('purgeDataSourceCacheDataSourcesDataSourceIdPurgeCachePost', 'dataSourceId', dataSourceId)
            const localVarPath = `/data-sources/{data_source_id}/purge-cache`
                .replace(`{${"data_source_id"}}`, encodeURIComponent(String(dataSourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates an existing data source.
         * @summary Update Data Source
         * @param {string} dataSourceId 
         * @param {DataSourceUpdate} dataSourceUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDataSourceDataSourcesDataSourceIdPut: async (dataSourceId: string, dataSourceUpdate: DataSourceUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataSourceId' is not null or undefined
            assertParamExists('updateDataSourceDataSourcesDataSourceIdPut', 'dataSourceId', dataSourceId)
            // verify required parameter 'dataSourceUpdate' is not null or undefined
            assertParamExists('updateDataSourceDataSourcesDataSourceIdPut', 'dataSourceUpdate', dataSourceUpdate)
            const localVarPath = `/data-sources/{data_source_id}`
                .replace(`{${"data_source_id"}}`, encodeURIComponent(String(dataSourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dataSourceUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DataSourcesApi - functional programming interface
 * @export
 */
export const DataSourcesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DataSourcesApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates a new data source.
         * @summary Create Data Source
         * @param {DataSourceCreate} dataSourceCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDataSourceDataSourcesPost(dataSourceCreate: DataSourceCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataSourceOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDataSourceDataSourcesPost(dataSourceCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataSourcesApi.createDataSourceDataSourcesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Executes a data source run based on the given input and context.  Args:     request: Request     data_source_id (str): The ID of the data source to run.     item (DataSourceRunInput): Input data containing parameters needed for execution.     source_repository (DataSourceRepository): The repository instance to interact with the data source.  Returns:     dict: A dictionary containing the result of the executed data source run.  Raises:     HTTPException: If the specified data source cannot be found, a 404 error will be raised.
         * @summary Data Source Run
         * @param {string} dataSourceId 
         * @param {DataSourceRunInput} dataSourceRunInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dataSourceRunDataSourcesDataSourceIdRunPost(dataSourceId: string, dataSourceRunInput: DataSourceRunInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Job>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dataSourceRunDataSourcesDataSourceIdRunPost(dataSourceId, dataSourceRunInput, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataSourcesApi.dataSourceRunDataSourcesDataSourceIdRunPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes a data source.
         * @summary Delete Data Source
         * @param {string} dataSourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDataSourceDataSourcesDataSourceIdDelete(dataSourceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDataSourceDataSourcesDataSourceIdDelete(dataSourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataSourcesApi.deleteDataSourceDataSourcesDataSourceIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves details for a specific data source.  Args:     request: Request     data_source_id (str): The ID of the data source to retrieve.     source_repository: DataSourceRepository  Returns:     dict: A dictionary containing data source details.
         * @summary Get Data Source
         * @param {string} dataSourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDataSourceDataSourcesDataSourceIdGet(dataSourceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataSourceOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDataSourceDataSourcesDataSourceIdGet(dataSourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataSourcesApi.getDataSourceDataSourcesDataSourceIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lists all data sources.  Args:     request: Request     source_repository: Data source repository  Returns:     list: A list of dictionaries, each representing a prompt.
         * @summary List Data Sources
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDataSourcesDataSourcesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DataSourceOut>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDataSourcesDataSourcesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataSourcesApi.listDataSourcesDataSourcesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Preview a data source.
         * @summary Preview Data Source
         * @param {DataSourcePreviewInput} dataSourcePreviewInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewDataSourceDataSourcesPreviewPost(dataSourcePreviewInput: DataSourcePreviewInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Job>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewDataSourceDataSourcesPreviewPost(dataSourcePreviewInput, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataSourcesApi.previewDataSourceDataSourcesPreviewPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Purges the cache for a data source.
         * @summary Purge Data Source Cache
         * @param {string} dataSourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async purgeDataSourceCacheDataSourcesDataSourceIdPurgeCachePost(dataSourceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.purgeDataSourceCacheDataSourcesDataSourceIdPurgeCachePost(dataSourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataSourcesApi.purgeDataSourceCacheDataSourcesDataSourceIdPurgeCachePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates an existing data source.
         * @summary Update Data Source
         * @param {string} dataSourceId 
         * @param {DataSourceUpdate} dataSourceUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDataSourceDataSourcesDataSourceIdPut(dataSourceId: string, dataSourceUpdate: DataSourceUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataSourceOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDataSourceDataSourcesDataSourceIdPut(dataSourceId, dataSourceUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataSourcesApi.updateDataSourceDataSourcesDataSourceIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DataSourcesApi - factory interface
 * @export
 */
export const DataSourcesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DataSourcesApiFp(configuration)
    return {
        /**
         * Creates a new data source.
         * @summary Create Data Source
         * @param {DataSourceCreate} dataSourceCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDataSourceDataSourcesPost(dataSourceCreate: DataSourceCreate, options?: RawAxiosRequestConfig): AxiosPromise<DataSourceOut> {
            return localVarFp.createDataSourceDataSourcesPost(dataSourceCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Executes a data source run based on the given input and context.  Args:     request: Request     data_source_id (str): The ID of the data source to run.     item (DataSourceRunInput): Input data containing parameters needed for execution.     source_repository (DataSourceRepository): The repository instance to interact with the data source.  Returns:     dict: A dictionary containing the result of the executed data source run.  Raises:     HTTPException: If the specified data source cannot be found, a 404 error will be raised.
         * @summary Data Source Run
         * @param {string} dataSourceId 
         * @param {DataSourceRunInput} dataSourceRunInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dataSourceRunDataSourcesDataSourceIdRunPost(dataSourceId: string, dataSourceRunInput: DataSourceRunInput, options?: RawAxiosRequestConfig): AxiosPromise<Job> {
            return localVarFp.dataSourceRunDataSourcesDataSourceIdRunPost(dataSourceId, dataSourceRunInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a data source.
         * @summary Delete Data Source
         * @param {string} dataSourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDataSourceDataSourcesDataSourceIdDelete(dataSourceId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteDataSourceDataSourcesDataSourceIdDelete(dataSourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves details for a specific data source.  Args:     request: Request     data_source_id (str): The ID of the data source to retrieve.     source_repository: DataSourceRepository  Returns:     dict: A dictionary containing data source details.
         * @summary Get Data Source
         * @param {string} dataSourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataSourceDataSourcesDataSourceIdGet(dataSourceId: string, options?: RawAxiosRequestConfig): AxiosPromise<DataSourceOut> {
            return localVarFp.getDataSourceDataSourcesDataSourceIdGet(dataSourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists all data sources.  Args:     request: Request     source_repository: Data source repository  Returns:     list: A list of dictionaries, each representing a prompt.
         * @summary List Data Sources
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDataSourcesDataSourcesGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<DataSourceOut>> {
            return localVarFp.listDataSourcesDataSourcesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Preview a data source.
         * @summary Preview Data Source
         * @param {DataSourcePreviewInput} dataSourcePreviewInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewDataSourceDataSourcesPreviewPost(dataSourcePreviewInput: DataSourcePreviewInput, options?: RawAxiosRequestConfig): AxiosPromise<Job> {
            return localVarFp.previewDataSourceDataSourcesPreviewPost(dataSourcePreviewInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Purges the cache for a data source.
         * @summary Purge Data Source Cache
         * @param {string} dataSourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purgeDataSourceCacheDataSourcesDataSourceIdPurgeCachePost(dataSourceId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.purgeDataSourceCacheDataSourcesDataSourceIdPurgeCachePost(dataSourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates an existing data source.
         * @summary Update Data Source
         * @param {string} dataSourceId 
         * @param {DataSourceUpdate} dataSourceUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDataSourceDataSourcesDataSourceIdPut(dataSourceId: string, dataSourceUpdate: DataSourceUpdate, options?: RawAxiosRequestConfig): AxiosPromise<DataSourceOut> {
            return localVarFp.updateDataSourceDataSourcesDataSourceIdPut(dataSourceId, dataSourceUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DataSourcesApi - object-oriented interface
 * @export
 * @class DataSourcesApi
 * @extends {BaseAPI}
 */
export class DataSourcesApi extends BaseAPI {
    /**
     * Creates a new data source.
     * @summary Create Data Source
     * @param {DataSourceCreate} dataSourceCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataSourcesApi
     */
    public createDataSourceDataSourcesPost(dataSourceCreate: DataSourceCreate, options?: RawAxiosRequestConfig) {
        return DataSourcesApiFp(this.configuration).createDataSourceDataSourcesPost(dataSourceCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Executes a data source run based on the given input and context.  Args:     request: Request     data_source_id (str): The ID of the data source to run.     item (DataSourceRunInput): Input data containing parameters needed for execution.     source_repository (DataSourceRepository): The repository instance to interact with the data source.  Returns:     dict: A dictionary containing the result of the executed data source run.  Raises:     HTTPException: If the specified data source cannot be found, a 404 error will be raised.
     * @summary Data Source Run
     * @param {string} dataSourceId 
     * @param {DataSourceRunInput} dataSourceRunInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataSourcesApi
     */
    public dataSourceRunDataSourcesDataSourceIdRunPost(dataSourceId: string, dataSourceRunInput: DataSourceRunInput, options?: RawAxiosRequestConfig) {
        return DataSourcesApiFp(this.configuration).dataSourceRunDataSourcesDataSourceIdRunPost(dataSourceId, dataSourceRunInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes a data source.
     * @summary Delete Data Source
     * @param {string} dataSourceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataSourcesApi
     */
    public deleteDataSourceDataSourcesDataSourceIdDelete(dataSourceId: string, options?: RawAxiosRequestConfig) {
        return DataSourcesApiFp(this.configuration).deleteDataSourceDataSourcesDataSourceIdDelete(dataSourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves details for a specific data source.  Args:     request: Request     data_source_id (str): The ID of the data source to retrieve.     source_repository: DataSourceRepository  Returns:     dict: A dictionary containing data source details.
     * @summary Get Data Source
     * @param {string} dataSourceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataSourcesApi
     */
    public getDataSourceDataSourcesDataSourceIdGet(dataSourceId: string, options?: RawAxiosRequestConfig) {
        return DataSourcesApiFp(this.configuration).getDataSourceDataSourcesDataSourceIdGet(dataSourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists all data sources.  Args:     request: Request     source_repository: Data source repository  Returns:     list: A list of dictionaries, each representing a prompt.
     * @summary List Data Sources
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataSourcesApi
     */
    public listDataSourcesDataSourcesGet(options?: RawAxiosRequestConfig) {
        return DataSourcesApiFp(this.configuration).listDataSourcesDataSourcesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Preview a data source.
     * @summary Preview Data Source
     * @param {DataSourcePreviewInput} dataSourcePreviewInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataSourcesApi
     */
    public previewDataSourceDataSourcesPreviewPost(dataSourcePreviewInput: DataSourcePreviewInput, options?: RawAxiosRequestConfig) {
        return DataSourcesApiFp(this.configuration).previewDataSourceDataSourcesPreviewPost(dataSourcePreviewInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Purges the cache for a data source.
     * @summary Purge Data Source Cache
     * @param {string} dataSourceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataSourcesApi
     */
    public purgeDataSourceCacheDataSourcesDataSourceIdPurgeCachePost(dataSourceId: string, options?: RawAxiosRequestConfig) {
        return DataSourcesApiFp(this.configuration).purgeDataSourceCacheDataSourcesDataSourceIdPurgeCachePost(dataSourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates an existing data source.
     * @summary Update Data Source
     * @param {string} dataSourceId 
     * @param {DataSourceUpdate} dataSourceUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataSourcesApi
     */
    public updateDataSourceDataSourcesDataSourceIdPut(dataSourceId: string, dataSourceUpdate: DataSourceUpdate, options?: RawAxiosRequestConfig) {
        return DataSourcesApiFp(this.configuration).updateDataSourceDataSourcesDataSourceIdPut(dataSourceId, dataSourceUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Endpoint that serves Prometheus metrics.
         * @summary Metrics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metricsMetricsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/metrics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * Endpoint that serves Prometheus metrics.
         * @summary Metrics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async metricsMetricsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.metricsMetricsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.metricsMetricsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * Endpoint that serves Prometheus metrics.
         * @summary Metrics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metricsMetricsGet(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.metricsMetricsGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * Endpoint that serves Prometheus metrics.
     * @summary Metrics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public metricsMetricsGet(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).metricsMetricsGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FacadesApi - axios parameter creator
 * @export
 */
export const FacadesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new facade.  Args:     request: Request     facade_input (FacadeCreateInput): Data for creating the new facade.     facade_repository (FacadeRepository): Repository for facade operations.  Returns:     FacadeOut: The created facade.
         * @summary Create Facade
         * @param {FacadeCreateInput} facadeCreateInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFacadeFacadesPost: async (facadeCreateInput: FacadeCreateInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facadeCreateInput' is not null or undefined
            assertParamExists('createFacadeFacadesPost', 'facadeCreateInput', facadeCreateInput)
            const localVarPath = `/facades/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(facadeCreateInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a facade.  Args:     request: Request     name (str): Name of the facade to delete.     facade_repository (FacadeRepository): Repository for facade operations.  Raises:     HTTPException: 404 if facade not found.
         * @summary Delete Facade
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFacadeFacadesNameDelete: async (name: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('deleteFacadeFacadesNameDelete', 'name', name)
            const localVarPath = `/facades/{name}`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a specific facade by its name.  Args:     request: Request     name (str): Name of the facade to retrieve.     facade_repository (FacadeRepository): Repository for facade operations.  Returns:     FacadeOut: The requested facade.  Raises:     HTTPException: 404 if facade not found.
         * @summary Get Facade By Name
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFacadeByNameFacadesNameGet: async (name: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('getFacadeByNameFacadesNameGet', 'name', name)
            const localVarPath = `/facades/{name}`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all available facades.  Args:     request: Request     facade_repository (FacadeRepository): Repository for facade operations.  Returns:     List[FacadeOut]: List of all facades.
         * @summary List Facades
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFacadesFacadesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/facades/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Run a facade\'s prompt with given input.  Args:     request: Request     name (str): Name of the facade to run.     facade_input (FacadePreviewInput): Input data for the prompt.     job_manager: Async Job manager     facade_repository (FacadeRepository): Repository for facade operations.  Returns:     job: Async Job Result.  Raises:     HTTPException: 404 if facade not found, 400 if LLM agent encounters an error.
         * @summary Preview Facade
         * @param {string} name 
         * @param {FacadePreviewInput} facadePreviewInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewFacadeFacadesNamePreviewPost: async (name: string, facadePreviewInput: FacadePreviewInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('previewFacadeFacadesNamePreviewPost', 'name', name)
            // verify required parameter 'facadePreviewInput' is not null or undefined
            assertParamExists('previewFacadeFacadesNamePreviewPost', 'facadePreviewInput', facadePreviewInput)
            const localVarPath = `/facades/{name}/preview`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(facadePreviewInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Purge the cache for a facade.  Args:     request: Request     name (str): Name of the facade to purge cache for.     facade_repository (FacadeRepository): Repository for facade operations.
         * @summary Purge Facade Cache
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purgeFacadeCacheFacadesNamePurgeCachePost: async (name: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('purgeFacadeCacheFacadesNamePurgeCachePost', 'name', name)
            const localVarPath = `/facades/{name}/purge-cache`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Run a facade\'s prompt with given input.  Args:     request: Request     name (str): Name of the facade to run.     facade_input (FacadeRunInput): Input data for the prompt.     job_manager: Async Job manager     facade_repository (FacadeRepository): Repository for facade operations.  Returns:     job: Async Job Result.  Raises:     HTTPException: 404 if facade not found, 400 if LLM agent encounters an error.
         * @summary Run Facade
         * @param {string} name 
         * @param {FacadeRunInput} facadeRunInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runFacadeFacadesNameRunPost: async (name: string, facadeRunInput: FacadeRunInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('runFacadeFacadesNameRunPost', 'name', name)
            // verify required parameter 'facadeRunInput' is not null or undefined
            assertParamExists('runFacadeFacadesNameRunPost', 'facadeRunInput', facadeRunInput)
            const localVarPath = `/facades/{name}/run`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(facadeRunInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing facade.  Args:     request: Request     name (str): Name of the facade to update.     facade_input (FacadeUpdateInput): Updated facade data.     facade_repository (FacadeRepository): Repository for facade operations.  Returns:     FacadeOut: The updated facade.
         * @summary Update Facade
         * @param {string} name 
         * @param {FacadeUpdateInput} facadeUpdateInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFacadeFacadesNamePut: async (name: string, facadeUpdateInput: FacadeUpdateInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('updateFacadeFacadesNamePut', 'name', name)
            // verify required parameter 'facadeUpdateInput' is not null or undefined
            assertParamExists('updateFacadeFacadesNamePut', 'facadeUpdateInput', facadeUpdateInput)
            const localVarPath = `/facades/{name}`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(facadeUpdateInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FacadesApi - functional programming interface
 * @export
 */
export const FacadesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FacadesApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new facade.  Args:     request: Request     facade_input (FacadeCreateInput): Data for creating the new facade.     facade_repository (FacadeRepository): Repository for facade operations.  Returns:     FacadeOut: The created facade.
         * @summary Create Facade
         * @param {FacadeCreateInput} facadeCreateInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFacadeFacadesPost(facadeCreateInput: FacadeCreateInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacadeOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFacadeFacadesPost(facadeCreateInput, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacadesApi.createFacadeFacadesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a facade.  Args:     request: Request     name (str): Name of the facade to delete.     facade_repository (FacadeRepository): Repository for facade operations.  Raises:     HTTPException: 404 if facade not found.
         * @summary Delete Facade
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFacadeFacadesNameDelete(name: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFacadeFacadesNameDelete(name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacadesApi.deleteFacadeFacadesNameDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a specific facade by its name.  Args:     request: Request     name (str): Name of the facade to retrieve.     facade_repository (FacadeRepository): Repository for facade operations.  Returns:     FacadeOut: The requested facade.  Raises:     HTTPException: 404 if facade not found.
         * @summary Get Facade By Name
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFacadeByNameFacadesNameGet(name: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacadeOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFacadeByNameFacadesNameGet(name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacadesApi.getFacadeByNameFacadesNameGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all available facades.  Args:     request: Request     facade_repository (FacadeRepository): Repository for facade operations.  Returns:     List[FacadeOut]: List of all facades.
         * @summary List Facades
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listFacadesFacadesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FacadeOut>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listFacadesFacadesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacadesApi.listFacadesFacadesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Run a facade\'s prompt with given input.  Args:     request: Request     name (str): Name of the facade to run.     facade_input (FacadePreviewInput): Input data for the prompt.     job_manager: Async Job manager     facade_repository (FacadeRepository): Repository for facade operations.  Returns:     job: Async Job Result.  Raises:     HTTPException: 404 if facade not found, 400 if LLM agent encounters an error.
         * @summary Preview Facade
         * @param {string} name 
         * @param {FacadePreviewInput} facadePreviewInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewFacadeFacadesNamePreviewPost(name: string, facadePreviewInput: FacadePreviewInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Job>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewFacadeFacadesNamePreviewPost(name, facadePreviewInput, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacadesApi.previewFacadeFacadesNamePreviewPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Purge the cache for a facade.  Args:     request: Request     name (str): Name of the facade to purge cache for.     facade_repository (FacadeRepository): Repository for facade operations.
         * @summary Purge Facade Cache
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async purgeFacadeCacheFacadesNamePurgeCachePost(name: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.purgeFacadeCacheFacadesNamePurgeCachePost(name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacadesApi.purgeFacadeCacheFacadesNamePurgeCachePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Run a facade\'s prompt with given input.  Args:     request: Request     name (str): Name of the facade to run.     facade_input (FacadeRunInput): Input data for the prompt.     job_manager: Async Job manager     facade_repository (FacadeRepository): Repository for facade operations.  Returns:     job: Async Job Result.  Raises:     HTTPException: 404 if facade not found, 400 if LLM agent encounters an error.
         * @summary Run Facade
         * @param {string} name 
         * @param {FacadeRunInput} facadeRunInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runFacadeFacadesNameRunPost(name: string, facadeRunInput: FacadeRunInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Job>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runFacadeFacadesNameRunPost(name, facadeRunInput, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacadesApi.runFacadeFacadesNameRunPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing facade.  Args:     request: Request     name (str): Name of the facade to update.     facade_input (FacadeUpdateInput): Updated facade data.     facade_repository (FacadeRepository): Repository for facade operations.  Returns:     FacadeOut: The updated facade.
         * @summary Update Facade
         * @param {string} name 
         * @param {FacadeUpdateInput} facadeUpdateInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFacadeFacadesNamePut(name: string, facadeUpdateInput: FacadeUpdateInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacadeOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFacadeFacadesNamePut(name, facadeUpdateInput, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacadesApi.updateFacadeFacadesNamePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FacadesApi - factory interface
 * @export
 */
export const FacadesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FacadesApiFp(configuration)
    return {
        /**
         * Create a new facade.  Args:     request: Request     facade_input (FacadeCreateInput): Data for creating the new facade.     facade_repository (FacadeRepository): Repository for facade operations.  Returns:     FacadeOut: The created facade.
         * @summary Create Facade
         * @param {FacadeCreateInput} facadeCreateInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFacadeFacadesPost(facadeCreateInput: FacadeCreateInput, options?: RawAxiosRequestConfig): AxiosPromise<FacadeOut> {
            return localVarFp.createFacadeFacadesPost(facadeCreateInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a facade.  Args:     request: Request     name (str): Name of the facade to delete.     facade_repository (FacadeRepository): Repository for facade operations.  Raises:     HTTPException: 404 if facade not found.
         * @summary Delete Facade
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFacadeFacadesNameDelete(name: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteFacadeFacadesNameDelete(name, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a specific facade by its name.  Args:     request: Request     name (str): Name of the facade to retrieve.     facade_repository (FacadeRepository): Repository for facade operations.  Returns:     FacadeOut: The requested facade.  Raises:     HTTPException: 404 if facade not found.
         * @summary Get Facade By Name
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFacadeByNameFacadesNameGet(name: string, options?: RawAxiosRequestConfig): AxiosPromise<FacadeOut> {
            return localVarFp.getFacadeByNameFacadesNameGet(name, options).then((request) => request(axios, basePath));
        },
        /**
         * List all available facades.  Args:     request: Request     facade_repository (FacadeRepository): Repository for facade operations.  Returns:     List[FacadeOut]: List of all facades.
         * @summary List Facades
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFacadesFacadesGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<FacadeOut>> {
            return localVarFp.listFacadesFacadesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Run a facade\'s prompt with given input.  Args:     request: Request     name (str): Name of the facade to run.     facade_input (FacadePreviewInput): Input data for the prompt.     job_manager: Async Job manager     facade_repository (FacadeRepository): Repository for facade operations.  Returns:     job: Async Job Result.  Raises:     HTTPException: 404 if facade not found, 400 if LLM agent encounters an error.
         * @summary Preview Facade
         * @param {string} name 
         * @param {FacadePreviewInput} facadePreviewInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewFacadeFacadesNamePreviewPost(name: string, facadePreviewInput: FacadePreviewInput, options?: RawAxiosRequestConfig): AxiosPromise<Job> {
            return localVarFp.previewFacadeFacadesNamePreviewPost(name, facadePreviewInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Purge the cache for a facade.  Args:     request: Request     name (str): Name of the facade to purge cache for.     facade_repository (FacadeRepository): Repository for facade operations.
         * @summary Purge Facade Cache
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purgeFacadeCacheFacadesNamePurgeCachePost(name: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.purgeFacadeCacheFacadesNamePurgeCachePost(name, options).then((request) => request(axios, basePath));
        },
        /**
         * Run a facade\'s prompt with given input.  Args:     request: Request     name (str): Name of the facade to run.     facade_input (FacadeRunInput): Input data for the prompt.     job_manager: Async Job manager     facade_repository (FacadeRepository): Repository for facade operations.  Returns:     job: Async Job Result.  Raises:     HTTPException: 404 if facade not found, 400 if LLM agent encounters an error.
         * @summary Run Facade
         * @param {string} name 
         * @param {FacadeRunInput} facadeRunInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runFacadeFacadesNameRunPost(name: string, facadeRunInput: FacadeRunInput, options?: RawAxiosRequestConfig): AxiosPromise<Job> {
            return localVarFp.runFacadeFacadesNameRunPost(name, facadeRunInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing facade.  Args:     request: Request     name (str): Name of the facade to update.     facade_input (FacadeUpdateInput): Updated facade data.     facade_repository (FacadeRepository): Repository for facade operations.  Returns:     FacadeOut: The updated facade.
         * @summary Update Facade
         * @param {string} name 
         * @param {FacadeUpdateInput} facadeUpdateInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFacadeFacadesNamePut(name: string, facadeUpdateInput: FacadeUpdateInput, options?: RawAxiosRequestConfig): AxiosPromise<FacadeOut> {
            return localVarFp.updateFacadeFacadesNamePut(name, facadeUpdateInput, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FacadesApi - object-oriented interface
 * @export
 * @class FacadesApi
 * @extends {BaseAPI}
 */
export class FacadesApi extends BaseAPI {
    /**
     * Create a new facade.  Args:     request: Request     facade_input (FacadeCreateInput): Data for creating the new facade.     facade_repository (FacadeRepository): Repository for facade operations.  Returns:     FacadeOut: The created facade.
     * @summary Create Facade
     * @param {FacadeCreateInput} facadeCreateInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacadesApi
     */
    public createFacadeFacadesPost(facadeCreateInput: FacadeCreateInput, options?: RawAxiosRequestConfig) {
        return FacadesApiFp(this.configuration).createFacadeFacadesPost(facadeCreateInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a facade.  Args:     request: Request     name (str): Name of the facade to delete.     facade_repository (FacadeRepository): Repository for facade operations.  Raises:     HTTPException: 404 if facade not found.
     * @summary Delete Facade
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacadesApi
     */
    public deleteFacadeFacadesNameDelete(name: string, options?: RawAxiosRequestConfig) {
        return FacadesApiFp(this.configuration).deleteFacadeFacadesNameDelete(name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a specific facade by its name.  Args:     request: Request     name (str): Name of the facade to retrieve.     facade_repository (FacadeRepository): Repository for facade operations.  Returns:     FacadeOut: The requested facade.  Raises:     HTTPException: 404 if facade not found.
     * @summary Get Facade By Name
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacadesApi
     */
    public getFacadeByNameFacadesNameGet(name: string, options?: RawAxiosRequestConfig) {
        return FacadesApiFp(this.configuration).getFacadeByNameFacadesNameGet(name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all available facades.  Args:     request: Request     facade_repository (FacadeRepository): Repository for facade operations.  Returns:     List[FacadeOut]: List of all facades.
     * @summary List Facades
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacadesApi
     */
    public listFacadesFacadesGet(options?: RawAxiosRequestConfig) {
        return FacadesApiFp(this.configuration).listFacadesFacadesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Run a facade\'s prompt with given input.  Args:     request: Request     name (str): Name of the facade to run.     facade_input (FacadePreviewInput): Input data for the prompt.     job_manager: Async Job manager     facade_repository (FacadeRepository): Repository for facade operations.  Returns:     job: Async Job Result.  Raises:     HTTPException: 404 if facade not found, 400 if LLM agent encounters an error.
     * @summary Preview Facade
     * @param {string} name 
     * @param {FacadePreviewInput} facadePreviewInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacadesApi
     */
    public previewFacadeFacadesNamePreviewPost(name: string, facadePreviewInput: FacadePreviewInput, options?: RawAxiosRequestConfig) {
        return FacadesApiFp(this.configuration).previewFacadeFacadesNamePreviewPost(name, facadePreviewInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Purge the cache for a facade.  Args:     request: Request     name (str): Name of the facade to purge cache for.     facade_repository (FacadeRepository): Repository for facade operations.
     * @summary Purge Facade Cache
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacadesApi
     */
    public purgeFacadeCacheFacadesNamePurgeCachePost(name: string, options?: RawAxiosRequestConfig) {
        return FacadesApiFp(this.configuration).purgeFacadeCacheFacadesNamePurgeCachePost(name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Run a facade\'s prompt with given input.  Args:     request: Request     name (str): Name of the facade to run.     facade_input (FacadeRunInput): Input data for the prompt.     job_manager: Async Job manager     facade_repository (FacadeRepository): Repository for facade operations.  Returns:     job: Async Job Result.  Raises:     HTTPException: 404 if facade not found, 400 if LLM agent encounters an error.
     * @summary Run Facade
     * @param {string} name 
     * @param {FacadeRunInput} facadeRunInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacadesApi
     */
    public runFacadeFacadesNameRunPost(name: string, facadeRunInput: FacadeRunInput, options?: RawAxiosRequestConfig) {
        return FacadesApiFp(this.configuration).runFacadeFacadesNameRunPost(name, facadeRunInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing facade.  Args:     request: Request     name (str): Name of the facade to update.     facade_input (FacadeUpdateInput): Updated facade data.     facade_repository (FacadeRepository): Repository for facade operations.  Returns:     FacadeOut: The updated facade.
     * @summary Update Facade
     * @param {string} name 
     * @param {FacadeUpdateInput} facadeUpdateInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacadesApi
     */
    public updateFacadeFacadesNamePut(name: string, facadeUpdateInput: FacadeUpdateInput, options?: RawAxiosRequestConfig) {
        return FacadesApiFp(this.configuration).updateFacadeFacadesNamePut(name, facadeUpdateInput, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InsightsApi - axios parameter creator
 * @export
 */
export const InsightsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve the daily chat volume for the specified date range and prompt ID.  Args:     request: FastApi Request     params: Query parameters including `start_date`, `end_date`, and `prompt_id` and `chat_id`.     repository: The InsightsRepository to fetch the data.
         * @summary Get Chats Per Day
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {string | null} [promptIds] 
         * @param {string | null} [chatId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatsPerDayInsightsChatsPerDayGet: async (startDate?: string | null, endDate?: string | null, promptIds?: string | null, chatId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/insights/chats-per-day`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (promptIds !== undefined) {
                localVarQueryParameter['prompt_ids'] = promptIds;
            }

            if (chatId !== undefined) {
                localVarQueryParameter['chat_id'] = chatId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the average elapsed time for the specified date range and prompt ID.  Args:     request: FastApi Request     params: Query parameters including `start_date`, `end_date`, and `prompt_id`.     repository: The InsightsRepository to fetch the data.  Returns:     A list of `DailyMetric` containing average elapsed times for each day.
         * @summary Get Elapsed Time
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {string | null} [promptIds] 
         * @param {string | null} [chatId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getElapsedTimeInsightsElapsedTimeGet: async (startDate?: string | null, endDate?: string | null, promptIds?: string | null, chatId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/insights/elapsed-time`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (promptIds !== undefined) {
                localVarQueryParameter['prompt_ids'] = promptIds;
            }

            if (chatId !== undefined) {
                localVarQueryParameter['chat_id'] = chatId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the daily error volume for the specified date range and prompt ID.  Args:     request: FastApi Request     params: Query parameters including `start_date`, `end_date`, and `prompt_id` and `chat_id`.     repository: The InsightsRepository to fetch the data.
         * @summary Get Error Volume
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {string | null} [promptIds] 
         * @param {string | null} [chatId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getErrorVolumeInsightsErrorVolumeGet: async (startDate?: string | null, endDate?: string | null, promptIds?: string | null, chatId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/insights/error-volume`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (promptIds !== undefined) {
                localVarQueryParameter['prompt_ids'] = promptIds;
            }

            if (chatId !== undefined) {
                localVarQueryParameter['chat_id'] = chatId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the daily run volume for the specified date range and prompt ID.  Args:     request: FastApi Request     params: Query parameters including `start_date`, `end_date`, and `prompt_id` and `chat_id`.     repository: The InsightsRepository to fetch the data.  Returns:     A list of `DailyMetric` containing daily run volumes for each day.
         * @summary Get Run Volume
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {string | null} [promptIds] 
         * @param {string | null} [chatId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRunVolumeInsightsRunVolumeGet: async (startDate?: string | null, endDate?: string | null, promptIds?: string | null, chatId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/insights/run-volume`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (promptIds !== undefined) {
                localVarQueryParameter['prompt_ids'] = promptIds;
            }

            if (chatId !== undefined) {
                localVarQueryParameter['chat_id'] = chatId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the total token usage for the specified date range and prompt ID.  Args:     request: FastApi Request     params: Query parameters including `start_date`, `end_date`, and `prompt_id` and `chat_id`.     repository: The InsightsRepository to fetch the data.  Returns:     A list of `DailyMetric` containing average token usage for each day.
         * @summary Get Token Usage
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {string | null} [promptIds] 
         * @param {string | null} [chatId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTokenUsageInsightsTokenUsageGet: async (startDate?: string | null, endDate?: string | null, promptIds?: string | null, chatId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/insights/token-usage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (promptIds !== undefined) {
                localVarQueryParameter['prompt_ids'] = promptIds;
            }

            if (chatId !== undefined) {
                localVarQueryParameter['chat_id'] = chatId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InsightsApi - functional programming interface
 * @export
 */
export const InsightsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InsightsApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve the daily chat volume for the specified date range and prompt ID.  Args:     request: FastApi Request     params: Query parameters including `start_date`, `end_date`, and `prompt_id` and `chat_id`.     repository: The InsightsRepository to fetch the data.
         * @summary Get Chats Per Day
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {string | null} [promptIds] 
         * @param {string | null} [chatId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChatsPerDayInsightsChatsPerDayGet(startDate?: string | null, endDate?: string | null, promptIds?: string | null, chatId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ChatPerDayMetric>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChatsPerDayInsightsChatsPerDayGet(startDate, endDate, promptIds, chatId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InsightsApi.getChatsPerDayInsightsChatsPerDayGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve the average elapsed time for the specified date range and prompt ID.  Args:     request: FastApi Request     params: Query parameters including `start_date`, `end_date`, and `prompt_id`.     repository: The InsightsRepository to fetch the data.  Returns:     A list of `DailyMetric` containing average elapsed times for each day.
         * @summary Get Elapsed Time
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {string | null} [promptIds] 
         * @param {string | null} [chatId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getElapsedTimeInsightsElapsedTimeGet(startDate?: string | null, endDate?: string | null, promptIds?: string | null, chatId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DailyMetric>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getElapsedTimeInsightsElapsedTimeGet(startDate, endDate, promptIds, chatId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InsightsApi.getElapsedTimeInsightsElapsedTimeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve the daily error volume for the specified date range and prompt ID.  Args:     request: FastApi Request     params: Query parameters including `start_date`, `end_date`, and `prompt_id` and `chat_id`.     repository: The InsightsRepository to fetch the data.
         * @summary Get Error Volume
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {string | null} [promptIds] 
         * @param {string | null} [chatId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getErrorVolumeInsightsErrorVolumeGet(startDate?: string | null, endDate?: string | null, promptIds?: string | null, chatId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DailyErrorVolumeMetric>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getErrorVolumeInsightsErrorVolumeGet(startDate, endDate, promptIds, chatId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InsightsApi.getErrorVolumeInsightsErrorVolumeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve the daily run volume for the specified date range and prompt ID.  Args:     request: FastApi Request     params: Query parameters including `start_date`, `end_date`, and `prompt_id` and `chat_id`.     repository: The InsightsRepository to fetch the data.  Returns:     A list of `DailyMetric` containing daily run volumes for each day.
         * @summary Get Run Volume
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {string | null} [promptIds] 
         * @param {string | null} [chatId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRunVolumeInsightsRunVolumeGet(startDate?: string | null, endDate?: string | null, promptIds?: string | null, chatId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DailyMetric>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRunVolumeInsightsRunVolumeGet(startDate, endDate, promptIds, chatId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InsightsApi.getRunVolumeInsightsRunVolumeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve the total token usage for the specified date range and prompt ID.  Args:     request: FastApi Request     params: Query parameters including `start_date`, `end_date`, and `prompt_id` and `chat_id`.     repository: The InsightsRepository to fetch the data.  Returns:     A list of `DailyMetric` containing average token usage for each day.
         * @summary Get Token Usage
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {string | null} [promptIds] 
         * @param {string | null} [chatId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTokenUsageInsightsTokenUsageGet(startDate?: string | null, endDate?: string | null, promptIds?: string | null, chatId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DailyMetric>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTokenUsageInsightsTokenUsageGet(startDate, endDate, promptIds, chatId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InsightsApi.getTokenUsageInsightsTokenUsageGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InsightsApi - factory interface
 * @export
 */
export const InsightsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InsightsApiFp(configuration)
    return {
        /**
         * Retrieve the daily chat volume for the specified date range and prompt ID.  Args:     request: FastApi Request     params: Query parameters including `start_date`, `end_date`, and `prompt_id` and `chat_id`.     repository: The InsightsRepository to fetch the data.
         * @summary Get Chats Per Day
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {string | null} [promptIds] 
         * @param {string | null} [chatId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatsPerDayInsightsChatsPerDayGet(startDate?: string | null, endDate?: string | null, promptIds?: string | null, chatId?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<Array<ChatPerDayMetric>> {
            return localVarFp.getChatsPerDayInsightsChatsPerDayGet(startDate, endDate, promptIds, chatId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the average elapsed time for the specified date range and prompt ID.  Args:     request: FastApi Request     params: Query parameters including `start_date`, `end_date`, and `prompt_id`.     repository: The InsightsRepository to fetch the data.  Returns:     A list of `DailyMetric` containing average elapsed times for each day.
         * @summary Get Elapsed Time
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {string | null} [promptIds] 
         * @param {string | null} [chatId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getElapsedTimeInsightsElapsedTimeGet(startDate?: string | null, endDate?: string | null, promptIds?: string | null, chatId?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<Array<DailyMetric>> {
            return localVarFp.getElapsedTimeInsightsElapsedTimeGet(startDate, endDate, promptIds, chatId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the daily error volume for the specified date range and prompt ID.  Args:     request: FastApi Request     params: Query parameters including `start_date`, `end_date`, and `prompt_id` and `chat_id`.     repository: The InsightsRepository to fetch the data.
         * @summary Get Error Volume
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {string | null} [promptIds] 
         * @param {string | null} [chatId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getErrorVolumeInsightsErrorVolumeGet(startDate?: string | null, endDate?: string | null, promptIds?: string | null, chatId?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<Array<DailyErrorVolumeMetric>> {
            return localVarFp.getErrorVolumeInsightsErrorVolumeGet(startDate, endDate, promptIds, chatId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the daily run volume for the specified date range and prompt ID.  Args:     request: FastApi Request     params: Query parameters including `start_date`, `end_date`, and `prompt_id` and `chat_id`.     repository: The InsightsRepository to fetch the data.  Returns:     A list of `DailyMetric` containing daily run volumes for each day.
         * @summary Get Run Volume
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {string | null} [promptIds] 
         * @param {string | null} [chatId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRunVolumeInsightsRunVolumeGet(startDate?: string | null, endDate?: string | null, promptIds?: string | null, chatId?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<Array<DailyMetric>> {
            return localVarFp.getRunVolumeInsightsRunVolumeGet(startDate, endDate, promptIds, chatId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the total token usage for the specified date range and prompt ID.  Args:     request: FastApi Request     params: Query parameters including `start_date`, `end_date`, and `prompt_id` and `chat_id`.     repository: The InsightsRepository to fetch the data.  Returns:     A list of `DailyMetric` containing average token usage for each day.
         * @summary Get Token Usage
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {string | null} [promptIds] 
         * @param {string | null} [chatId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTokenUsageInsightsTokenUsageGet(startDate?: string | null, endDate?: string | null, promptIds?: string | null, chatId?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<Array<DailyMetric>> {
            return localVarFp.getTokenUsageInsightsTokenUsageGet(startDate, endDate, promptIds, chatId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InsightsApi - object-oriented interface
 * @export
 * @class InsightsApi
 * @extends {BaseAPI}
 */
export class InsightsApi extends BaseAPI {
    /**
     * Retrieve the daily chat volume for the specified date range and prompt ID.  Args:     request: FastApi Request     params: Query parameters including `start_date`, `end_date`, and `prompt_id` and `chat_id`.     repository: The InsightsRepository to fetch the data.
     * @summary Get Chats Per Day
     * @param {string | null} [startDate] 
     * @param {string | null} [endDate] 
     * @param {string | null} [promptIds] 
     * @param {string | null} [chatId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InsightsApi
     */
    public getChatsPerDayInsightsChatsPerDayGet(startDate?: string | null, endDate?: string | null, promptIds?: string | null, chatId?: string | null, options?: RawAxiosRequestConfig) {
        return InsightsApiFp(this.configuration).getChatsPerDayInsightsChatsPerDayGet(startDate, endDate, promptIds, chatId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the average elapsed time for the specified date range and prompt ID.  Args:     request: FastApi Request     params: Query parameters including `start_date`, `end_date`, and `prompt_id`.     repository: The InsightsRepository to fetch the data.  Returns:     A list of `DailyMetric` containing average elapsed times for each day.
     * @summary Get Elapsed Time
     * @param {string | null} [startDate] 
     * @param {string | null} [endDate] 
     * @param {string | null} [promptIds] 
     * @param {string | null} [chatId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InsightsApi
     */
    public getElapsedTimeInsightsElapsedTimeGet(startDate?: string | null, endDate?: string | null, promptIds?: string | null, chatId?: string | null, options?: RawAxiosRequestConfig) {
        return InsightsApiFp(this.configuration).getElapsedTimeInsightsElapsedTimeGet(startDate, endDate, promptIds, chatId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the daily error volume for the specified date range and prompt ID.  Args:     request: FastApi Request     params: Query parameters including `start_date`, `end_date`, and `prompt_id` and `chat_id`.     repository: The InsightsRepository to fetch the data.
     * @summary Get Error Volume
     * @param {string | null} [startDate] 
     * @param {string | null} [endDate] 
     * @param {string | null} [promptIds] 
     * @param {string | null} [chatId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InsightsApi
     */
    public getErrorVolumeInsightsErrorVolumeGet(startDate?: string | null, endDate?: string | null, promptIds?: string | null, chatId?: string | null, options?: RawAxiosRequestConfig) {
        return InsightsApiFp(this.configuration).getErrorVolumeInsightsErrorVolumeGet(startDate, endDate, promptIds, chatId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the daily run volume for the specified date range and prompt ID.  Args:     request: FastApi Request     params: Query parameters including `start_date`, `end_date`, and `prompt_id` and `chat_id`.     repository: The InsightsRepository to fetch the data.  Returns:     A list of `DailyMetric` containing daily run volumes for each day.
     * @summary Get Run Volume
     * @param {string | null} [startDate] 
     * @param {string | null} [endDate] 
     * @param {string | null} [promptIds] 
     * @param {string | null} [chatId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InsightsApi
     */
    public getRunVolumeInsightsRunVolumeGet(startDate?: string | null, endDate?: string | null, promptIds?: string | null, chatId?: string | null, options?: RawAxiosRequestConfig) {
        return InsightsApiFp(this.configuration).getRunVolumeInsightsRunVolumeGet(startDate, endDate, promptIds, chatId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the total token usage for the specified date range and prompt ID.  Args:     request: FastApi Request     params: Query parameters including `start_date`, `end_date`, and `prompt_id` and `chat_id`.     repository: The InsightsRepository to fetch the data.  Returns:     A list of `DailyMetric` containing average token usage for each day.
     * @summary Get Token Usage
     * @param {string | null} [startDate] 
     * @param {string | null} [endDate] 
     * @param {string | null} [promptIds] 
     * @param {string | null} [chatId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InsightsApi
     */
    public getTokenUsageInsightsTokenUsageGet(startDate?: string | null, endDate?: string | null, promptIds?: string | null, chatId?: string | null, options?: RawAxiosRequestConfig) {
        return InsightsApiFp(this.configuration).getTokenUsageInsightsTokenUsageGet(startDate, endDate, promptIds, chatId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * JobsApi - axios parameter creator
 * @export
 */
export const JobsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get the status and result of an async prompt execution job.  Args:     request: Request     job_id (str): The ID of the job to check.  Returns:     dict: Job status and result information.
         * @summary Get Job Status
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobStatusJobsJobIdGet: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('getJobStatusJobsJobIdGet', 'jobId', jobId)
            const localVarPath = `/jobs/{job_id}`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * JobsApi - functional programming interface
 * @export
 */
export const JobsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = JobsApiAxiosParamCreator(configuration)
    return {
        /**
         * Get the status and result of an async prompt execution job.  Args:     request: Request     job_id (str): The ID of the job to check.  Returns:     dict: Job status and result information.
         * @summary Get Job Status
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJobStatusJobsJobIdGet(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Job>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJobStatusJobsJobIdGet(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.getJobStatusJobsJobIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * JobsApi - factory interface
 * @export
 */
export const JobsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = JobsApiFp(configuration)
    return {
        /**
         * Get the status and result of an async prompt execution job.  Args:     request: Request     job_id (str): The ID of the job to check.  Returns:     dict: Job status and result information.
         * @summary Get Job Status
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobStatusJobsJobIdGet(jobId: string, options?: RawAxiosRequestConfig): AxiosPromise<Job> {
            return localVarFp.getJobStatusJobsJobIdGet(jobId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * JobsApi - object-oriented interface
 * @export
 * @class JobsApi
 * @extends {BaseAPI}
 */
export class JobsApi extends BaseAPI {
    /**
     * Get the status and result of an async prompt execution job.  Args:     request: Request     job_id (str): The ID of the job to check.  Returns:     dict: Job status and result information.
     * @summary Get Job Status
     * @param {string} jobId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    public getJobStatusJobsJobIdGet(jobId: string, options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).getJobStatusJobsJobIdGet(jobId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LLMApi - axios parameter creator
 * @export
 */
export const LLMApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new LLM model.
         * @summary Create Llm Model
         * @param {LLMModelUpsert} lLMModelUpsert 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLlmModelLlmModelsPost: async (lLMModelUpsert: LLMModelUpsert, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'lLMModelUpsert' is not null or undefined
            assertParamExists('createLlmModelLlmModelsPost', 'lLMModelUpsert', lLMModelUpsert)
            const localVarPath = `/llm/models`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(lLMModelUpsert, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an existing LLM model.
         * @summary Delete Llm Model
         * @param {string} llmModelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLlmModelLlmModelsLlmModelIdDelete: async (llmModelId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'llmModelId' is not null or undefined
            assertParamExists('deleteLlmModelLlmModelsLlmModelIdDelete', 'llmModelId', llmModelId)
            const localVarPath = `/llm/models/{llm_model_id}`
                .replace(`{${"llm_model_id"}}`, encodeURIComponent(String(llmModelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all LLM agents.
         * @summary Get Llm Agents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLlmAgentsLlmAgentsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/llm/agents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get an existing LLM model.
         * @summary Get Llm Model
         * @param {string} llmModelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLlmModelLlmModelsLlmModelIdGet: async (llmModelId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'llmModelId' is not null or undefined
            assertParamExists('getLlmModelLlmModelsLlmModelIdGet', 'llmModelId', llmModelId)
            const localVarPath = `/llm/models/{llm_model_id}`
                .replace(`{${"llm_model_id"}}`, encodeURIComponent(String(llmModelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all LLM models.
         * @summary Get Llm Models
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLlmModelsLlmModelsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/llm/models`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing LLM model.
         * @summary Update Llm Model
         * @param {string} llmModelId 
         * @param {LLMModelUpsert} lLMModelUpsert 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLlmModelLlmModelsLlmModelIdPut: async (llmModelId: string, lLMModelUpsert: LLMModelUpsert, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'llmModelId' is not null or undefined
            assertParamExists('updateLlmModelLlmModelsLlmModelIdPut', 'llmModelId', llmModelId)
            // verify required parameter 'lLMModelUpsert' is not null or undefined
            assertParamExists('updateLlmModelLlmModelsLlmModelIdPut', 'lLMModelUpsert', lLMModelUpsert)
            const localVarPath = `/llm/models/{llm_model_id}`
                .replace(`{${"llm_model_id"}}`, encodeURIComponent(String(llmModelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(lLMModelUpsert, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LLMApi - functional programming interface
 * @export
 */
export const LLMApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LLMApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new LLM model.
         * @summary Create Llm Model
         * @param {LLMModelUpsert} lLMModelUpsert 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLlmModelLlmModelsPost(lLMModelUpsert: LLMModelUpsert, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LLMModelOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLlmModelLlmModelsPost(lLMModelUpsert, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LLMApi.createLlmModelLlmModelsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete an existing LLM model.
         * @summary Delete Llm Model
         * @param {string} llmModelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLlmModelLlmModelsLlmModelIdDelete(llmModelId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLlmModelLlmModelsLlmModelIdDelete(llmModelId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LLMApi.deleteLlmModelLlmModelsLlmModelIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all LLM agents.
         * @summary Get Llm Agents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLlmAgentsLlmAgentsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LLMAgentOut>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLlmAgentsLlmAgentsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LLMApi.getLlmAgentsLlmAgentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get an existing LLM model.
         * @summary Get Llm Model
         * @param {string} llmModelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLlmModelLlmModelsLlmModelIdGet(llmModelId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LLMModelOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLlmModelLlmModelsLlmModelIdGet(llmModelId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LLMApi.getLlmModelLlmModelsLlmModelIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all LLM models.
         * @summary Get Llm Models
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLlmModelsLlmModelsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LLMModelOut>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLlmModelsLlmModelsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LLMApi.getLlmModelsLlmModelsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing LLM model.
         * @summary Update Llm Model
         * @param {string} llmModelId 
         * @param {LLMModelUpsert} lLMModelUpsert 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLlmModelLlmModelsLlmModelIdPut(llmModelId: string, lLMModelUpsert: LLMModelUpsert, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LLMModelOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLlmModelLlmModelsLlmModelIdPut(llmModelId, lLMModelUpsert, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LLMApi.updateLlmModelLlmModelsLlmModelIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LLMApi - factory interface
 * @export
 */
export const LLMApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LLMApiFp(configuration)
    return {
        /**
         * Create a new LLM model.
         * @summary Create Llm Model
         * @param {LLMModelUpsert} lLMModelUpsert 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLlmModelLlmModelsPost(lLMModelUpsert: LLMModelUpsert, options?: RawAxiosRequestConfig): AxiosPromise<LLMModelOut> {
            return localVarFp.createLlmModelLlmModelsPost(lLMModelUpsert, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete an existing LLM model.
         * @summary Delete Llm Model
         * @param {string} llmModelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLlmModelLlmModelsLlmModelIdDelete(llmModelId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteLlmModelLlmModelsLlmModelIdDelete(llmModelId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all LLM agents.
         * @summary Get Llm Agents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLlmAgentsLlmAgentsGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<LLMAgentOut>> {
            return localVarFp.getLlmAgentsLlmAgentsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Get an existing LLM model.
         * @summary Get Llm Model
         * @param {string} llmModelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLlmModelLlmModelsLlmModelIdGet(llmModelId: string, options?: RawAxiosRequestConfig): AxiosPromise<LLMModelOut> {
            return localVarFp.getLlmModelLlmModelsLlmModelIdGet(llmModelId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all LLM models.
         * @summary Get Llm Models
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLlmModelsLlmModelsGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<LLMModelOut>> {
            return localVarFp.getLlmModelsLlmModelsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing LLM model.
         * @summary Update Llm Model
         * @param {string} llmModelId 
         * @param {LLMModelUpsert} lLMModelUpsert 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLlmModelLlmModelsLlmModelIdPut(llmModelId: string, lLMModelUpsert: LLMModelUpsert, options?: RawAxiosRequestConfig): AxiosPromise<LLMModelOut> {
            return localVarFp.updateLlmModelLlmModelsLlmModelIdPut(llmModelId, lLMModelUpsert, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LLMApi - object-oriented interface
 * @export
 * @class LLMApi
 * @extends {BaseAPI}
 */
export class LLMApi extends BaseAPI {
    /**
     * Create a new LLM model.
     * @summary Create Llm Model
     * @param {LLMModelUpsert} lLMModelUpsert 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LLMApi
     */
    public createLlmModelLlmModelsPost(lLMModelUpsert: LLMModelUpsert, options?: RawAxiosRequestConfig) {
        return LLMApiFp(this.configuration).createLlmModelLlmModelsPost(lLMModelUpsert, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete an existing LLM model.
     * @summary Delete Llm Model
     * @param {string} llmModelId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LLMApi
     */
    public deleteLlmModelLlmModelsLlmModelIdDelete(llmModelId: string, options?: RawAxiosRequestConfig) {
        return LLMApiFp(this.configuration).deleteLlmModelLlmModelsLlmModelIdDelete(llmModelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all LLM agents.
     * @summary Get Llm Agents
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LLMApi
     */
    public getLlmAgentsLlmAgentsGet(options?: RawAxiosRequestConfig) {
        return LLMApiFp(this.configuration).getLlmAgentsLlmAgentsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get an existing LLM model.
     * @summary Get Llm Model
     * @param {string} llmModelId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LLMApi
     */
    public getLlmModelLlmModelsLlmModelIdGet(llmModelId: string, options?: RawAxiosRequestConfig) {
        return LLMApiFp(this.configuration).getLlmModelLlmModelsLlmModelIdGet(llmModelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all LLM models.
     * @summary Get Llm Models
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LLMApi
     */
    public getLlmModelsLlmModelsGet(options?: RawAxiosRequestConfig) {
        return LLMApiFp(this.configuration).getLlmModelsLlmModelsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing LLM model.
     * @summary Update Llm Model
     * @param {string} llmModelId 
     * @param {LLMModelUpsert} lLMModelUpsert 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LLMApi
     */
    public updateLlmModelLlmModelsLlmModelIdPut(llmModelId: string, lLMModelUpsert: LLMModelUpsert, options?: RawAxiosRequestConfig) {
        return LLMApiFp(this.configuration).updateLlmModelLlmModelsLlmModelIdPut(llmModelId, lLMModelUpsert, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PromptsApi - axios parameter creator
 * @export
 */
export const PromptsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Change the status of a prompt.  Args:     request: Request object     prompt_id: ID of the prompt to change status     prompt_status_input: PromptStatusInput     prompt_repository: PromptRepository  Returns:     PromptOut: The changed prompt status  Raises:     HTTPException: If prompt is not found or cannot be changed
         * @summary Change Prompt Status
         * @param {string} promptId 
         * @param {PromptStatusInput} promptStatusInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePromptStatusPromptsPromptIdStatusPut: async (promptId: string, promptStatusInput: PromptStatusInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'promptId' is not null or undefined
            assertParamExists('changePromptStatusPromptsPromptIdStatusPut', 'promptId', promptId)
            // verify required parameter 'promptStatusInput' is not null or undefined
            assertParamExists('changePromptStatusPromptsPromptIdStatusPut', 'promptStatusInput', promptStatusInput)
            const localVarPath = `/prompts/{prompt_id}/status`
                .replace(`{${"prompt_id"}}`, encodeURIComponent(String(promptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(promptStatusInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new prompt.  Args:     request: FastApi Request     prompt_input (PromptCreateInput): The details of the prompt to create.     prompt_repository: PromptRepository  Returns:     PromptOut: The created prompt details.
         * @summary Create Prompt
         * @param {PromptCreateInput} promptCreateInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPromptPromptsPost: async (promptCreateInput: PromptCreateInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'promptCreateInput' is not null or undefined
            assertParamExists('createPromptPromptsPost', 'promptCreateInput', promptCreateInput)
            const localVarPath = `/prompts/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(promptCreateInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes an existing prompt. Only allowed if status is \'draft\'.  Args:     request: FastApi Request     prompt_id (str): The ID of the prompt to delete.     prompt_repository: PromptRepository  Returns:     None
         * @summary Delete Prompt
         * @param {string} promptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePromptPromptsPromptIdDelete: async (promptId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'promptId' is not null or undefined
            assertParamExists('deletePromptPromptsPromptIdDelete', 'promptId', promptId)
            const localVarPath = `/prompts/{prompt_id}`
                .replace(`{${"prompt_id"}}`, encodeURIComponent(String(promptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves child prompts of prompt  Args:     request: FastApi Request     prompt_id (str): The ID of the prompt to retrieve.     prompt_repository: PromptRepository  Returns:     dict: A dictionary containing prompt details.
         * @summary Get Child Prompts
         * @param {string} promptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChildPromptsPromptsPromptIdChildPromptsGet: async (promptId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'promptId' is not null or undefined
            assertParamExists('getChildPromptsPromptsPromptIdChildPromptsGet', 'promptId', promptId)
            const localVarPath = `/prompts/{prompt_id}/child-prompts`
                .replace(`{${"prompt_id"}}`, encodeURIComponent(String(promptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves details for a specific LLM prompt.  Args:     request: FastApi Request     prompt_id (str): The ID of the prompt to retrieve.     prompt_repository: PromptRepository  Returns:     dict: A dictionary containing prompt details.
         * @summary Get Prompt
         * @param {string} promptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromptPromptsPromptIdGet: async (promptId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'promptId' is not null or undefined
            assertParamExists('getPromptPromptsPromptIdGet', 'promptId', promptId)
            const localVarPath = `/prompts/{prompt_id}`
                .replace(`{${"prompt_id"}}`, encodeURIComponent(String(promptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a tree structure of a prompt and its children.  Args:     request: FastApi Request     prompt_id (str): The ID of the prompt to retrieve.     prompt_repository: PromptRepository  Returns:     dict: A dictionary containing the tree structure of the prompt.
         * @summary Get Prompt Tree
         * @param {string} promptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromptTreePromptsPromptIdTreeGet: async (promptId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'promptId' is not null or undefined
            assertParamExists('getPromptTreePromptsPromptIdTreeGet', 'promptId', promptId)
            const localVarPath = `/prompts/{prompt_id}/tree`
                .replace(`{${"prompt_id"}}`, encodeURIComponent(String(promptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves all versions for a specific LLM prompt.  Args:     request: FastApi Request     prompt_id (str): The ID of the prompt to retrieve.     prompt_repository: PromptRepository  Returns:     List[PromptVersionOut]: A list of all prompt versions.
         * @summary Get Prompt Versions
         * @param {string} promptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromptVersionsPromptsPromptIdVersionsGet: async (promptId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'promptId' is not null or undefined
            assertParamExists('getPromptVersionsPromptsPromptIdVersionsGet', 'promptId', promptId)
            const localVarPath = `/prompts/{prompt_id}/versions`
                .replace(`{${"prompt_id"}}`, encodeURIComponent(String(promptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List prompt logs.
         * @summary List Prompt Logs
         * @param {number} [page] The page number (1-based indexing)
         * @param {number} [pageSize] Number of items per page
         * @param {boolean | null} [isSucceed] Filter logs by success status
         * @param {string | null} [promptIds] Filter logs by prompt ids
         * @param {string | null} [chatIds] Filter logs by chat ids
         * @param {string | null} [startDate] The start date of the logs
         * @param {string | null} [endDate] The end date of the logs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPromptLogsPromptsLogsGet: async (page?: number, pageSize?: number, isSucceed?: boolean | null, promptIds?: string | null, chatIds?: string | null, startDate?: string | null, endDate?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/prompts/logs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (isSucceed !== undefined) {
                localVarQueryParameter['is_succeed'] = isSucceed;
            }

            if (promptIds !== undefined) {
                localVarQueryParameter['prompt_ids'] = promptIds;
            }

            if (chatIds !== undefined) {
                localVarQueryParameter['chat_ids'] = chatIds;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists all available LLM prompts.  Args:     request: FastApi Request     prompt_repository: Prompt Repository  Returns:     list: A list of dictionaries, each representing a prompt.
         * @summary List Prompts
         * @param {string} [status] Filter prompts by status, Comma separated list of statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPromptsPromptsGet: async (status?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/prompts/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Preview LLM prompt.  Args:     request: FastApi Request     prompt_input: PreviewPrompt     job_manager: Async Job Manager  Returns:     Job: Async Job result
         * @summary Preview Prompt
         * @param {PreviewPrompt} previewPrompt 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewPromptPromptsPreviewPost: async (previewPrompt: PreviewPrompt, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'previewPrompt' is not null or undefined
            assertParamExists('previewPromptPromptsPreviewPost', 'previewPrompt', previewPrompt)
            const localVarPath = `/prompts/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(previewPrompt, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Executes a specific LLM prompt.  Args:     request: FastApi Request     prompt_id (str): The ID of the prompt to execute.     prompt_input: PromptRunInput,     prompt_repository: PromptRepository     job_manager: Async Job Manager  Returns:     Job: Async Job result
         * @summary Run Prompt
         * @param {string} promptId 
         * @param {PromptRunInput} promptRunInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runPromptPromptsPromptIdRunPost: async (promptId: string, promptRunInput: PromptRunInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'promptId' is not null or undefined
            assertParamExists('runPromptPromptsPromptIdRunPost', 'promptId', promptId)
            // verify required parameter 'promptRunInput' is not null or undefined
            assertParamExists('runPromptPromptsPromptIdRunPost', 'promptRunInput', promptRunInput)
            const localVarPath = `/prompts/{prompt_id}/run`
                .replace(`{${"prompt_id"}}`, encodeURIComponent(String(promptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(promptRunInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates an existing prompt. Only allowed if status is \'draft\'.  Args:     request: FastApi Request     prompt_id (str): The ID of the prompt to update.     prompt_input (PromptUpdateInput): The updated prompt details.     prompt_repository: PromptRepository  Returns:     PromptOut: The updated prompt details.
         * @summary Update Prompt
         * @param {string} promptId 
         * @param {PromptUpdateInput} promptUpdateInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePromptPromptsPromptIdPut: async (promptId: string, promptUpdateInput: PromptUpdateInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'promptId' is not null or undefined
            assertParamExists('updatePromptPromptsPromptIdPut', 'promptId', promptId)
            // verify required parameter 'promptUpdateInput' is not null or undefined
            assertParamExists('updatePromptPromptsPromptIdPut', 'promptUpdateInput', promptUpdateInput)
            const localVarPath = `/prompts/{prompt_id}`
                .replace(`{${"prompt_id"}}`, encodeURIComponent(String(promptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(promptUpdateInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PromptsApi - functional programming interface
 * @export
 */
export const PromptsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PromptsApiAxiosParamCreator(configuration)
    return {
        /**
         * Change the status of a prompt.  Args:     request: Request object     prompt_id: ID of the prompt to change status     prompt_status_input: PromptStatusInput     prompt_repository: PromptRepository  Returns:     PromptOut: The changed prompt status  Raises:     HTTPException: If prompt is not found or cannot be changed
         * @summary Change Prompt Status
         * @param {string} promptId 
         * @param {PromptStatusInput} promptStatusInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changePromptStatusPromptsPromptIdStatusPut(promptId: string, promptStatusInput: PromptStatusInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PromptOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changePromptStatusPromptsPromptIdStatusPut(promptId, promptStatusInput, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromptsApi.changePromptStatusPromptsPromptIdStatusPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a new prompt.  Args:     request: FastApi Request     prompt_input (PromptCreateInput): The details of the prompt to create.     prompt_repository: PromptRepository  Returns:     PromptOut: The created prompt details.
         * @summary Create Prompt
         * @param {PromptCreateInput} promptCreateInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPromptPromptsPost(promptCreateInput: PromptCreateInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PromptOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPromptPromptsPost(promptCreateInput, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromptsApi.createPromptPromptsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes an existing prompt. Only allowed if status is \'draft\'.  Args:     request: FastApi Request     prompt_id (str): The ID of the prompt to delete.     prompt_repository: PromptRepository  Returns:     None
         * @summary Delete Prompt
         * @param {string} promptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePromptPromptsPromptIdDelete(promptId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePromptPromptsPromptIdDelete(promptId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromptsApi.deletePromptPromptsPromptIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves child prompts of prompt  Args:     request: FastApi Request     prompt_id (str): The ID of the prompt to retrieve.     prompt_repository: PromptRepository  Returns:     dict: A dictionary containing prompt details.
         * @summary Get Child Prompts
         * @param {string} promptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChildPromptsPromptsPromptIdChildPromptsGet(promptId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PromptOut>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChildPromptsPromptsPromptIdChildPromptsGet(promptId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromptsApi.getChildPromptsPromptsPromptIdChildPromptsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves details for a specific LLM prompt.  Args:     request: FastApi Request     prompt_id (str): The ID of the prompt to retrieve.     prompt_repository: PromptRepository  Returns:     dict: A dictionary containing prompt details.
         * @summary Get Prompt
         * @param {string} promptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPromptPromptsPromptIdGet(promptId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PromptOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPromptPromptsPromptIdGet(promptId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromptsApi.getPromptPromptsPromptIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a tree structure of a prompt and its children.  Args:     request: FastApi Request     prompt_id (str): The ID of the prompt to retrieve.     prompt_repository: PromptRepository  Returns:     dict: A dictionary containing the tree structure of the prompt.
         * @summary Get Prompt Tree
         * @param {string} promptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPromptTreePromptsPromptIdTreeGet(promptId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PromptTreeOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPromptTreePromptsPromptIdTreeGet(promptId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromptsApi.getPromptTreePromptsPromptIdTreeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves all versions for a specific LLM prompt.  Args:     request: FastApi Request     prompt_id (str): The ID of the prompt to retrieve.     prompt_repository: PromptRepository  Returns:     List[PromptVersionOut]: A list of all prompt versions.
         * @summary Get Prompt Versions
         * @param {string} promptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPromptVersionsPromptsPromptIdVersionsGet(promptId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PromptVersionOut>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPromptVersionsPromptsPromptIdVersionsGet(promptId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromptsApi.getPromptVersionsPromptsPromptIdVersionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List prompt logs.
         * @summary List Prompt Logs
         * @param {number} [page] The page number (1-based indexing)
         * @param {number} [pageSize] Number of items per page
         * @param {boolean | null} [isSucceed] Filter logs by success status
         * @param {string | null} [promptIds] Filter logs by prompt ids
         * @param {string | null} [chatIds] Filter logs by chat ids
         * @param {string | null} [startDate] The start date of the logs
         * @param {string | null} [endDate] The end date of the logs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPromptLogsPromptsLogsGet(page?: number, pageSize?: number, isSucceed?: boolean | null, promptIds?: string | null, chatIds?: string | null, startDate?: string | null, endDate?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PromptLogOut>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPromptLogsPromptsLogsGet(page, pageSize, isSucceed, promptIds, chatIds, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromptsApi.listPromptLogsPromptsLogsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lists all available LLM prompts.  Args:     request: FastApi Request     prompt_repository: Prompt Repository  Returns:     list: A list of dictionaries, each representing a prompt.
         * @summary List Prompts
         * @param {string} [status] Filter prompts by status, Comma separated list of statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPromptsPromptsGet(status?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PromptOut>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPromptsPromptsGet(status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromptsApi.listPromptsPromptsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Preview LLM prompt.  Args:     request: FastApi Request     prompt_input: PreviewPrompt     job_manager: Async Job Manager  Returns:     Job: Async Job result
         * @summary Preview Prompt
         * @param {PreviewPrompt} previewPrompt 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewPromptPromptsPreviewPost(previewPrompt: PreviewPrompt, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Job>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewPromptPromptsPreviewPost(previewPrompt, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromptsApi.previewPromptPromptsPreviewPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Executes a specific LLM prompt.  Args:     request: FastApi Request     prompt_id (str): The ID of the prompt to execute.     prompt_input: PromptRunInput,     prompt_repository: PromptRepository     job_manager: Async Job Manager  Returns:     Job: Async Job result
         * @summary Run Prompt
         * @param {string} promptId 
         * @param {PromptRunInput} promptRunInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runPromptPromptsPromptIdRunPost(promptId: string, promptRunInput: PromptRunInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Job>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runPromptPromptsPromptIdRunPost(promptId, promptRunInput, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromptsApi.runPromptPromptsPromptIdRunPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates an existing prompt. Only allowed if status is \'draft\'.  Args:     request: FastApi Request     prompt_id (str): The ID of the prompt to update.     prompt_input (PromptUpdateInput): The updated prompt details.     prompt_repository: PromptRepository  Returns:     PromptOut: The updated prompt details.
         * @summary Update Prompt
         * @param {string} promptId 
         * @param {PromptUpdateInput} promptUpdateInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePromptPromptsPromptIdPut(promptId: string, promptUpdateInput: PromptUpdateInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PromptOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePromptPromptsPromptIdPut(promptId, promptUpdateInput, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromptsApi.updatePromptPromptsPromptIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PromptsApi - factory interface
 * @export
 */
export const PromptsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PromptsApiFp(configuration)
    return {
        /**
         * Change the status of a prompt.  Args:     request: Request object     prompt_id: ID of the prompt to change status     prompt_status_input: PromptStatusInput     prompt_repository: PromptRepository  Returns:     PromptOut: The changed prompt status  Raises:     HTTPException: If prompt is not found or cannot be changed
         * @summary Change Prompt Status
         * @param {string} promptId 
         * @param {PromptStatusInput} promptStatusInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePromptStatusPromptsPromptIdStatusPut(promptId: string, promptStatusInput: PromptStatusInput, options?: RawAxiosRequestConfig): AxiosPromise<PromptOut> {
            return localVarFp.changePromptStatusPromptsPromptIdStatusPut(promptId, promptStatusInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new prompt.  Args:     request: FastApi Request     prompt_input (PromptCreateInput): The details of the prompt to create.     prompt_repository: PromptRepository  Returns:     PromptOut: The created prompt details.
         * @summary Create Prompt
         * @param {PromptCreateInput} promptCreateInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPromptPromptsPost(promptCreateInput: PromptCreateInput, options?: RawAxiosRequestConfig): AxiosPromise<PromptOut> {
            return localVarFp.createPromptPromptsPost(promptCreateInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes an existing prompt. Only allowed if status is \'draft\'.  Args:     request: FastApi Request     prompt_id (str): The ID of the prompt to delete.     prompt_repository: PromptRepository  Returns:     None
         * @summary Delete Prompt
         * @param {string} promptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePromptPromptsPromptIdDelete(promptId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePromptPromptsPromptIdDelete(promptId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves child prompts of prompt  Args:     request: FastApi Request     prompt_id (str): The ID of the prompt to retrieve.     prompt_repository: PromptRepository  Returns:     dict: A dictionary containing prompt details.
         * @summary Get Child Prompts
         * @param {string} promptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChildPromptsPromptsPromptIdChildPromptsGet(promptId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PromptOut>> {
            return localVarFp.getChildPromptsPromptsPromptIdChildPromptsGet(promptId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves details for a specific LLM prompt.  Args:     request: FastApi Request     prompt_id (str): The ID of the prompt to retrieve.     prompt_repository: PromptRepository  Returns:     dict: A dictionary containing prompt details.
         * @summary Get Prompt
         * @param {string} promptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromptPromptsPromptIdGet(promptId: string, options?: RawAxiosRequestConfig): AxiosPromise<PromptOut> {
            return localVarFp.getPromptPromptsPromptIdGet(promptId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a tree structure of a prompt and its children.  Args:     request: FastApi Request     prompt_id (str): The ID of the prompt to retrieve.     prompt_repository: PromptRepository  Returns:     dict: A dictionary containing the tree structure of the prompt.
         * @summary Get Prompt Tree
         * @param {string} promptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromptTreePromptsPromptIdTreeGet(promptId: string, options?: RawAxiosRequestConfig): AxiosPromise<PromptTreeOut> {
            return localVarFp.getPromptTreePromptsPromptIdTreeGet(promptId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves all versions for a specific LLM prompt.  Args:     request: FastApi Request     prompt_id (str): The ID of the prompt to retrieve.     prompt_repository: PromptRepository  Returns:     List[PromptVersionOut]: A list of all prompt versions.
         * @summary Get Prompt Versions
         * @param {string} promptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromptVersionsPromptsPromptIdVersionsGet(promptId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PromptVersionOut>> {
            return localVarFp.getPromptVersionsPromptsPromptIdVersionsGet(promptId, options).then((request) => request(axios, basePath));
        },
        /**
         * List prompt logs.
         * @summary List Prompt Logs
         * @param {number} [page] The page number (1-based indexing)
         * @param {number} [pageSize] Number of items per page
         * @param {boolean | null} [isSucceed] Filter logs by success status
         * @param {string | null} [promptIds] Filter logs by prompt ids
         * @param {string | null} [chatIds] Filter logs by chat ids
         * @param {string | null} [startDate] The start date of the logs
         * @param {string | null} [endDate] The end date of the logs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPromptLogsPromptsLogsGet(page?: number, pageSize?: number, isSucceed?: boolean | null, promptIds?: string | null, chatIds?: string | null, startDate?: string | null, endDate?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<Array<PromptLogOut>> {
            return localVarFp.listPromptLogsPromptsLogsGet(page, pageSize, isSucceed, promptIds, chatIds, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists all available LLM prompts.  Args:     request: FastApi Request     prompt_repository: Prompt Repository  Returns:     list: A list of dictionaries, each representing a prompt.
         * @summary List Prompts
         * @param {string} [status] Filter prompts by status, Comma separated list of statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPromptsPromptsGet(status?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PromptOut>> {
            return localVarFp.listPromptsPromptsGet(status, options).then((request) => request(axios, basePath));
        },
        /**
         * Preview LLM prompt.  Args:     request: FastApi Request     prompt_input: PreviewPrompt     job_manager: Async Job Manager  Returns:     Job: Async Job result
         * @summary Preview Prompt
         * @param {PreviewPrompt} previewPrompt 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewPromptPromptsPreviewPost(previewPrompt: PreviewPrompt, options?: RawAxiosRequestConfig): AxiosPromise<Job> {
            return localVarFp.previewPromptPromptsPreviewPost(previewPrompt, options).then((request) => request(axios, basePath));
        },
        /**
         * Executes a specific LLM prompt.  Args:     request: FastApi Request     prompt_id (str): The ID of the prompt to execute.     prompt_input: PromptRunInput,     prompt_repository: PromptRepository     job_manager: Async Job Manager  Returns:     Job: Async Job result
         * @summary Run Prompt
         * @param {string} promptId 
         * @param {PromptRunInput} promptRunInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runPromptPromptsPromptIdRunPost(promptId: string, promptRunInput: PromptRunInput, options?: RawAxiosRequestConfig): AxiosPromise<Job> {
            return localVarFp.runPromptPromptsPromptIdRunPost(promptId, promptRunInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates an existing prompt. Only allowed if status is \'draft\'.  Args:     request: FastApi Request     prompt_id (str): The ID of the prompt to update.     prompt_input (PromptUpdateInput): The updated prompt details.     prompt_repository: PromptRepository  Returns:     PromptOut: The updated prompt details.
         * @summary Update Prompt
         * @param {string} promptId 
         * @param {PromptUpdateInput} promptUpdateInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePromptPromptsPromptIdPut(promptId: string, promptUpdateInput: PromptUpdateInput, options?: RawAxiosRequestConfig): AxiosPromise<PromptOut> {
            return localVarFp.updatePromptPromptsPromptIdPut(promptId, promptUpdateInput, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PromptsApi - object-oriented interface
 * @export
 * @class PromptsApi
 * @extends {BaseAPI}
 */
export class PromptsApi extends BaseAPI {
    /**
     * Change the status of a prompt.  Args:     request: Request object     prompt_id: ID of the prompt to change status     prompt_status_input: PromptStatusInput     prompt_repository: PromptRepository  Returns:     PromptOut: The changed prompt status  Raises:     HTTPException: If prompt is not found or cannot be changed
     * @summary Change Prompt Status
     * @param {string} promptId 
     * @param {PromptStatusInput} promptStatusInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptsApi
     */
    public changePromptStatusPromptsPromptIdStatusPut(promptId: string, promptStatusInput: PromptStatusInput, options?: RawAxiosRequestConfig) {
        return PromptsApiFp(this.configuration).changePromptStatusPromptsPromptIdStatusPut(promptId, promptStatusInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new prompt.  Args:     request: FastApi Request     prompt_input (PromptCreateInput): The details of the prompt to create.     prompt_repository: PromptRepository  Returns:     PromptOut: The created prompt details.
     * @summary Create Prompt
     * @param {PromptCreateInput} promptCreateInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptsApi
     */
    public createPromptPromptsPost(promptCreateInput: PromptCreateInput, options?: RawAxiosRequestConfig) {
        return PromptsApiFp(this.configuration).createPromptPromptsPost(promptCreateInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes an existing prompt. Only allowed if status is \'draft\'.  Args:     request: FastApi Request     prompt_id (str): The ID of the prompt to delete.     prompt_repository: PromptRepository  Returns:     None
     * @summary Delete Prompt
     * @param {string} promptId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptsApi
     */
    public deletePromptPromptsPromptIdDelete(promptId: string, options?: RawAxiosRequestConfig) {
        return PromptsApiFp(this.configuration).deletePromptPromptsPromptIdDelete(promptId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves child prompts of prompt  Args:     request: FastApi Request     prompt_id (str): The ID of the prompt to retrieve.     prompt_repository: PromptRepository  Returns:     dict: A dictionary containing prompt details.
     * @summary Get Child Prompts
     * @param {string} promptId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptsApi
     */
    public getChildPromptsPromptsPromptIdChildPromptsGet(promptId: string, options?: RawAxiosRequestConfig) {
        return PromptsApiFp(this.configuration).getChildPromptsPromptsPromptIdChildPromptsGet(promptId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves details for a specific LLM prompt.  Args:     request: FastApi Request     prompt_id (str): The ID of the prompt to retrieve.     prompt_repository: PromptRepository  Returns:     dict: A dictionary containing prompt details.
     * @summary Get Prompt
     * @param {string} promptId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptsApi
     */
    public getPromptPromptsPromptIdGet(promptId: string, options?: RawAxiosRequestConfig) {
        return PromptsApiFp(this.configuration).getPromptPromptsPromptIdGet(promptId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a tree structure of a prompt and its children.  Args:     request: FastApi Request     prompt_id (str): The ID of the prompt to retrieve.     prompt_repository: PromptRepository  Returns:     dict: A dictionary containing the tree structure of the prompt.
     * @summary Get Prompt Tree
     * @param {string} promptId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptsApi
     */
    public getPromptTreePromptsPromptIdTreeGet(promptId: string, options?: RawAxiosRequestConfig) {
        return PromptsApiFp(this.configuration).getPromptTreePromptsPromptIdTreeGet(promptId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves all versions for a specific LLM prompt.  Args:     request: FastApi Request     prompt_id (str): The ID of the prompt to retrieve.     prompt_repository: PromptRepository  Returns:     List[PromptVersionOut]: A list of all prompt versions.
     * @summary Get Prompt Versions
     * @param {string} promptId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptsApi
     */
    public getPromptVersionsPromptsPromptIdVersionsGet(promptId: string, options?: RawAxiosRequestConfig) {
        return PromptsApiFp(this.configuration).getPromptVersionsPromptsPromptIdVersionsGet(promptId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List prompt logs.
     * @summary List Prompt Logs
     * @param {number} [page] The page number (1-based indexing)
     * @param {number} [pageSize] Number of items per page
     * @param {boolean | null} [isSucceed] Filter logs by success status
     * @param {string | null} [promptIds] Filter logs by prompt ids
     * @param {string | null} [chatIds] Filter logs by chat ids
     * @param {string | null} [startDate] The start date of the logs
     * @param {string | null} [endDate] The end date of the logs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptsApi
     */
    public listPromptLogsPromptsLogsGet(page?: number, pageSize?: number, isSucceed?: boolean | null, promptIds?: string | null, chatIds?: string | null, startDate?: string | null, endDate?: string | null, options?: RawAxiosRequestConfig) {
        return PromptsApiFp(this.configuration).listPromptLogsPromptsLogsGet(page, pageSize, isSucceed, promptIds, chatIds, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists all available LLM prompts.  Args:     request: FastApi Request     prompt_repository: Prompt Repository  Returns:     list: A list of dictionaries, each representing a prompt.
     * @summary List Prompts
     * @param {string} [status] Filter prompts by status, Comma separated list of statuses
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptsApi
     */
    public listPromptsPromptsGet(status?: string, options?: RawAxiosRequestConfig) {
        return PromptsApiFp(this.configuration).listPromptsPromptsGet(status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Preview LLM prompt.  Args:     request: FastApi Request     prompt_input: PreviewPrompt     job_manager: Async Job Manager  Returns:     Job: Async Job result
     * @summary Preview Prompt
     * @param {PreviewPrompt} previewPrompt 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptsApi
     */
    public previewPromptPromptsPreviewPost(previewPrompt: PreviewPrompt, options?: RawAxiosRequestConfig) {
        return PromptsApiFp(this.configuration).previewPromptPromptsPreviewPost(previewPrompt, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Executes a specific LLM prompt.  Args:     request: FastApi Request     prompt_id (str): The ID of the prompt to execute.     prompt_input: PromptRunInput,     prompt_repository: PromptRepository     job_manager: Async Job Manager  Returns:     Job: Async Job result
     * @summary Run Prompt
     * @param {string} promptId 
     * @param {PromptRunInput} promptRunInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptsApi
     */
    public runPromptPromptsPromptIdRunPost(promptId: string, promptRunInput: PromptRunInput, options?: RawAxiosRequestConfig) {
        return PromptsApiFp(this.configuration).runPromptPromptsPromptIdRunPost(promptId, promptRunInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates an existing prompt. Only allowed if status is \'draft\'.  Args:     request: FastApi Request     prompt_id (str): The ID of the prompt to update.     prompt_input (PromptUpdateInput): The updated prompt details.     prompt_repository: PromptRepository  Returns:     PromptOut: The updated prompt details.
     * @summary Update Prompt
     * @param {string} promptId 
     * @param {PromptUpdateInput} promptUpdateInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptsApi
     */
    public updatePromptPromptsPromptIdPut(promptId: string, promptUpdateInput: PromptUpdateInput, options?: RawAxiosRequestConfig) {
        return PromptsApiFp(this.configuration).updatePromptPromptsPromptIdPut(promptId, promptUpdateInput, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ServiceApi - axios parameter creator
 * @export
 */
export const ServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Checks the service status. Returns a detailed status report of all service dependencies.  Args:     request: Request
         * @summary Get Service Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceStatusStatusGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ServiceApi - functional programming interface
 * @export
 */
export const ServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * Checks the service status. Returns a detailed status report of all service dependencies.  Args:     request: Request
         * @summary Get Service Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServiceStatusStatusGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServiceStatusStatusGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceApi.getServiceStatusStatusGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ServiceApi - factory interface
 * @export
 */
export const ServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ServiceApiFp(configuration)
    return {
        /**
         * Checks the service status. Returns a detailed status report of all service dependencies.  Args:     request: Request
         * @summary Get Service Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceStatusStatusGet(options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getServiceStatusStatusGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ServiceApi - object-oriented interface
 * @export
 * @class ServiceApi
 * @extends {BaseAPI}
 */
export class ServiceApi extends BaseAPI {
    /**
     * Checks the service status. Returns a detailed status report of all service dependencies.  Args:     request: Request
     * @summary Get Service Status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    public getServiceStatusStatusGet(options?: RawAxiosRequestConfig) {
        return ServiceApiFp(this.configuration).getServiceStatusStatusGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TestCasesApi - axios parameter creator
 * @export
 */
export const TestCasesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new test case.
         * @summary Create Test Case
         * @param {PromptTestCaseCreateInput} promptTestCaseCreateInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTestCaseTestCasesPost: async (promptTestCaseCreateInput: PromptTestCaseCreateInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'promptTestCaseCreateInput' is not null or undefined
            assertParamExists('createTestCaseTestCasesPost', 'promptTestCaseCreateInput', promptTestCaseCreateInput)
            const localVarPath = `/test-cases/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(promptTestCaseCreateInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all results for a test case.
         * @summary Get Test Case Results
         * @param {string} testCaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestCaseResultsTestCasesTestCaseIdResultsGet: async (testCaseId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testCaseId' is not null or undefined
            assertParamExists('getTestCaseResultsTestCasesTestCaseIdResultsGet', 'testCaseId', testCaseId)
            const localVarPath = `/test-cases/{test_case_id}/results`
                .replace(`{${"test_case_id"}}`, encodeURIComponent(String(testCaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a test case by ID.
         * @summary Get Test Case
         * @param {string} testCaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestCaseTestCasesTestCaseIdGet: async (testCaseId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testCaseId' is not null or undefined
            assertParamExists('getTestCaseTestCasesTestCaseIdGet', 'testCaseId', testCaseId)
            const localVarPath = `/test-cases/{test_case_id}`
                .replace(`{${"test_case_id"}}`, encodeURIComponent(String(testCaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all test cases.
         * @summary List Test Cases
         * @param {string | null} [promptId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTestCasesTestCasesGet: async (promptId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/test-cases/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (promptId !== undefined) {
                localVarQueryParameter['prompt_id'] = promptId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestCasesApi - functional programming interface
 * @export
 */
export const TestCasesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestCasesApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new test case.
         * @summary Create Test Case
         * @param {PromptTestCaseCreateInput} promptTestCaseCreateInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTestCaseTestCasesPost(promptTestCaseCreateInput: PromptTestCaseCreateInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PromptTestCaseOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTestCaseTestCasesPost(promptTestCaseCreateInput, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestCasesApi.createTestCaseTestCasesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all results for a test case.
         * @summary Get Test Case Results
         * @param {string} testCaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTestCaseResultsTestCasesTestCaseIdResultsGet(testCaseId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PromptTestCaseResultOut>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTestCaseResultsTestCasesTestCaseIdResultsGet(testCaseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestCasesApi.getTestCaseResultsTestCasesTestCaseIdResultsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a test case by ID.
         * @summary Get Test Case
         * @param {string} testCaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTestCaseTestCasesTestCaseIdGet(testCaseId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PromptTestCaseOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTestCaseTestCasesTestCaseIdGet(testCaseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestCasesApi.getTestCaseTestCasesTestCaseIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all test cases.
         * @summary List Test Cases
         * @param {string | null} [promptId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTestCasesTestCasesGet(promptId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PromptTestCaseOut>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTestCasesTestCasesGet(promptId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestCasesApi.listTestCasesTestCasesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TestCasesApi - factory interface
 * @export
 */
export const TestCasesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestCasesApiFp(configuration)
    return {
        /**
         * Create a new test case.
         * @summary Create Test Case
         * @param {PromptTestCaseCreateInput} promptTestCaseCreateInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTestCaseTestCasesPost(promptTestCaseCreateInput: PromptTestCaseCreateInput, options?: RawAxiosRequestConfig): AxiosPromise<PromptTestCaseOut> {
            return localVarFp.createTestCaseTestCasesPost(promptTestCaseCreateInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all results for a test case.
         * @summary Get Test Case Results
         * @param {string} testCaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestCaseResultsTestCasesTestCaseIdResultsGet(testCaseId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PromptTestCaseResultOut>> {
            return localVarFp.getTestCaseResultsTestCasesTestCaseIdResultsGet(testCaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a test case by ID.
         * @summary Get Test Case
         * @param {string} testCaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestCaseTestCasesTestCaseIdGet(testCaseId: string, options?: RawAxiosRequestConfig): AxiosPromise<PromptTestCaseOut> {
            return localVarFp.getTestCaseTestCasesTestCaseIdGet(testCaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * List all test cases.
         * @summary List Test Cases
         * @param {string | null} [promptId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTestCasesTestCasesGet(promptId?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<Array<PromptTestCaseOut>> {
            return localVarFp.listTestCasesTestCasesGet(promptId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TestCasesApi - object-oriented interface
 * @export
 * @class TestCasesApi
 * @extends {BaseAPI}
 */
export class TestCasesApi extends BaseAPI {
    /**
     * Create a new test case.
     * @summary Create Test Case
     * @param {PromptTestCaseCreateInput} promptTestCaseCreateInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestCasesApi
     */
    public createTestCaseTestCasesPost(promptTestCaseCreateInput: PromptTestCaseCreateInput, options?: RawAxiosRequestConfig) {
        return TestCasesApiFp(this.configuration).createTestCaseTestCasesPost(promptTestCaseCreateInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all results for a test case.
     * @summary Get Test Case Results
     * @param {string} testCaseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestCasesApi
     */
    public getTestCaseResultsTestCasesTestCaseIdResultsGet(testCaseId: string, options?: RawAxiosRequestConfig) {
        return TestCasesApiFp(this.configuration).getTestCaseResultsTestCasesTestCaseIdResultsGet(testCaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a test case by ID.
     * @summary Get Test Case
     * @param {string} testCaseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestCasesApi
     */
    public getTestCaseTestCasesTestCaseIdGet(testCaseId: string, options?: RawAxiosRequestConfig) {
        return TestCasesApiFp(this.configuration).getTestCaseTestCasesTestCaseIdGet(testCaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all test cases.
     * @summary List Test Cases
     * @param {string | null} [promptId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestCasesApi
     */
    public listTestCasesTestCasesGet(promptId?: string | null, options?: RawAxiosRequestConfig) {
        return TestCasesApiFp(this.configuration).listTestCasesTestCasesGet(promptId, options).then((request) => request(this.axios, this.basePath));
    }
}



